import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  StringCompanionObject_instance1kavzb69ik84p as StringCompanionObject_instance,
  Unit_instanceat14thlj150z as Unit_instance,
  emptyList1g2z5xcrvp2zy as emptyList,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  toString1pkumu07cwy4m as toString,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  captureStack1fzi4aczwc4hg as captureStack,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KClass1cc9rfeybg8hs as KClass,
  isInterface3d6p8outrmvmk as isInterface,
  Triple1vhi3d0dgpnjb as Triple,
  getKClass1s3j9wy1cofik as getKClass,
  Paire9pteg33gng7 as Pair,
  Entry2xmjmyutzoq3p as Entry,
  KtMap140uvy3s5zad8 as KtMap,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  HashMap1a0ld5kgwhmhv as HashMap,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashSet2dzve9y63nf0v as HashSet,
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
  copyToArray2j022khrow2yi as copyToArray,
  _Result___get_value__impl__bjfvqgbxrwpgk5sesh as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2jp2gwqhnirp8 as _Result___get_isFailure__impl__jpiriv,
  Result3t1vadv16kmzk as Result,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Iterable1y3qizuf89iou as Iterable,
  isBlank1dvkhjjvox3p0 as isBlank,
  toList383f556t1dixk as toList,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
  withIndex3s8q7w1g0hyfn as withIndex,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  lazy2hsh8ze7j6ikd as lazy_0,
  contentEqualsaf55p28mnw74 as contentEquals,
  until1jbpn0z3f8lbg as until,
  joinToString1cxrrlmo0chqs as joinToString,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Long2qws0ah9gnpki as Long,
  Char19o2r8palgjof as Char,
  createThis2j2avj17cvnv2 as createThis,
  Duration__toIsoString_impl_9h6wsm2kf5is6ue36 as Duration__toIsoString_impl_9h6wsm,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  hashCodeq5arwsb9dgti as hashCode,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  isArray1hxjqtqy632bc as isArray,
  arrayIterator3lgwvgteckzhv as arrayIterator,
  asList2ho2pewtsfvv as asList,
  step18s9qzr5xwxat as step,
  getValue48kllevslyh6 as getValue,
  longArray288a0fctlmjmj as longArray,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_lastIndex1y2f6o9u8hnf7 as get_lastIndex,
  countTrailingZeroBits1k55x07cygoff as countTrailingZeroBits,
  indexOf3ic8eacwbbrog as indexOf,
  contentToString3ujacv8hqfipd as contentToString,
  Enum3alwj03lh1n41 as Enum,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  toString30pk9tzaqopn as toString_0,
  KTypeParameter1s8efufd4mbj5 as KTypeParameter,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  booleanArray2jdug9b51huk7 as booleanArray,
  emptyMapr06gerzljqtm as emptyMap,
  Companion_getInstance107vs7n7usf4y as Companion_getInstance_0,
  isCharArray21auq5hbrg68m as isCharArray,
  charArray2ujmm1qusno00 as charArray,
  DoubleCompanionObject_instance173s5lyb0q261 as DoubleCompanionObject_instance,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  FloatCompanionObject_instance2nv8eonbbzzfx as FloatCompanionObject_instance,
  isFloatArrayjjscnqphw92j as isFloatArray,
  Companion_getInstance1krakgr3yg44t as Companion_getInstance_1,
  isLongArray2fdt3z7yu3ef as isLongArray,
  Companion_getInstance2r8lbbjwejmb0 as Companion_getInstance_2,
  _ULongArray___get_size__impl__ju6dtr5v7zdjz7p45k as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l32q6yolvdd31u5 as _ULongArray___init__impl__twm1l3,
  _ULong___init__impl__c78o9k1neui78jb9mlg as _ULong___init__impl__c78o9k,
  ULongArray__get_impl_pr71q92g1kdq5mz2hdv as ULongArray__get_impl_pr71q9,
  _ULong___get_data__impl__fggpzb77rs34yu2akv as _ULong___get_data__impl__fggpzb,
  IntCompanionObject_instance3gkmaao3ynimd as IntCompanionObject_instance,
  isIntArrayeijsubfngq38 as isIntArray,
  Companion_getInstance316n37o3eume as Companion_getInstance_3,
  _UIntArray___get_size__impl__r6l8ci3qgksw2fv2zbg as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc61y58bc9dz2k51 as _UIntArray___init__impl__ghjpc6,
  _UInt___init__impl__l7qpdl2x2ja0qtrydmg as _UInt___init__impl__l7qpdl,
  UIntArray__get_impl_gp5kzae60hwt0gkwo9 as UIntArray__get_impl_gp5kza,
  _UInt___get_data__impl__f0vqqw1wfqgh301wggv as _UInt___get_data__impl__f0vqqw,
  ShortCompanionObject_instance12gf1264cm017 as ShortCompanionObject_instance,
  isShortArraywz30zxwtqi8h as isShortArray,
  Companion_getInstance3956vha054dts as Companion_getInstance_4,
  _UShortArray___get_size__impl__jqto1b36yuj0vpbb4fa as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26ef3n50inn0xrhd8 as _UShortArray___init__impl__9b26ef,
  _UShort___init__impl__jigrne18f2wrm3i4dpy as _UShort___init__impl__jigrne,
  UShortArray__get_impl_fnbhmx1y5d8996erjf3 as UShortArray__get_impl_fnbhmx,
  _UShort___get_data__impl__g02453buibbzrpmeid as _UShort___get_data__impl__g0245,
  ByteCompanionObject_instance1hjbskmeqhwpn as ByteCompanionObject_instance,
  isByteArray4nnzfn1x4o3w as isByteArray,
  Companion_getInstance16xypb6k4bny3 as Companion_getInstance_5,
  _UByteArray___get_size__impl__h6pkdv15deqqx7xzfdr as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n1hit86mr6wg8d as _UByteArray___init__impl__ip4y9n,
  _UByte___init__impl__g9hnc43i8t7wecfr79w as _UByte___init__impl__g9hnc4,
  UByteArray__get_impl_t5f3hv1encpe8trq9zx as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qr1jhbnu489etgz as _UByte___get_data__impl__jof9qr,
  BooleanCompanionObject_instance3nn0izprmvlr6 as BooleanCompanionObject_instance,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  _ULongArray___get_storage__impl__28e64jz3ai25vchwgx as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l3owlgsbcrjm9i as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh1fkdkvkvugioz as ULongArray__set_impl_z19mvh,
  copyOf3rutauicler23 as copyOf_3,
  _UIntArray___get_storage__impl__92a0v0roqxtd6s3fgh as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc6c5ddvnp6r87k as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu21dnkvvxogtuwl as UIntArray__set_impl_7f2zu2,
  copyOf39s58md6y6rn6 as copyOf_4,
  _UShortArray___get_storage__impl__t2jpv53svtj69qk6zql as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef2aibpqatnrmu4 as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp2i4vsez7wuaa8 as UShortArray__set_impl_6d8whp,
  copyOfwy6h3t5vzqpl as copyOf_5,
  _UByteArray___get_storage__impl__d4kctt1v2w0kp012p35 as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n3sp5zyufbcv0v as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicn11526muxjy7z7 as UByteArray__set_impl_jvcicn,
  copyOf37mht4mx7mjgh as copyOf_6,
  Unitkvevlwgzwiuc as Unit,
  trimIndent1qytc1wvt8suh as trimIndent,
  equals2v6cggk171b6e as equals_0,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  toString14fd7g605f91p as toString_1,
  titlecase36e9fbud5gg4t as titlecase,
  isLowerCase16nv9n55l9laa as isLowerCase,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  ULong3f9k7s38t3rfp as ULong,
  UInt1hthisrv6cndi as UInt,
  UShort26xnqty60t7le as UShort,
  UBytep4j7r1t64gz1 as UByte,
  mapOf1xd03cq9cnmy8 as mapOf,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  get_lastIndex1yw0x4k50k51w as get_lastIndex_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  get_js1ale1wr4fbvs0 as get_js,
  findAssociatedObject1kb88g16k1goa as findAssociatedObject,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  get_indicesc04v40g017hw as get_indices,
  get_indices377latqcai313 as get_indices_0,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class SerializationStrategy {}
class DeserializationStrategy {}
class KSerializer {}
class AbstractPolymorphicSerializer {
  zcc(encoder, value) {
    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.jcc();
    var composite = encoder.fcg(descriptor);
    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
    composite.vch(this.jcc(), 0, actualSerializer.jcc().ice());
    var tmp = this.jcc();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.xch(tmp, 1, tmp$ret$0, value);
    composite.gcg(descriptor);
  }
  kcc(encoder, value) {
    return this.zcc(encoder, !(value == null) ? value : THROW_CCE());
  }
  lcc(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.jcc();
    var composite = decoder.fcg(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
      var klassName = null;
      var value = null;
      if (composite.vcg()) {
        tmp$ret$0 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.wcg(this.jcc());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.pcg(this.jcc(), index);
            break;
          case 1:
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              var value_0 = klassName;
              // Inline function 'kotlin.contracts.contract' call
              if (value_0 == null) {
                // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException.l(toString(message));
              } else {
                tmp$ret$2 = value_0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer_0(this, composite, klassName);
            value = composite.scg(this.jcc(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException.icd('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        var value_1 = value;
        // Inline function 'kotlin.contracts.contract' call
        if (value_1 == null) {
          // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException.l(toString(message_0));
        } else {
          tmp$ret$4 = value_1;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$0;
    composite.gcg(descriptor);
    return result;
  }
  acd(decoder, klassName) {
    return decoder.ucg().eci(this.ycc(), klassName);
  }
  bcd(encoder, value) {
    return encoder.ucg().fci(this.ycc(), value);
  }
}
class PolymorphicSerializer extends AbstractPolymorphicSerializer {
  constructor(baseClass) {
    super();
    this.vcc_1 = baseClass;
    this.wcc_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.xcc_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
  }
  ycc() {
    return this.vcc_1;
  }
  jcc() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.xcc_1;
    descriptor$factory();
    return this_0.u1();
  }
  toString() {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.vcc_1) + ')';
  }
}
class SealedClassSerializer extends AbstractPolymorphicSerializer {
  jcc() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ccd_1;
    descriptor$factory_0();
    return this_0.u1();
  }
}
class SerializationException extends IllegalArgumentException {
  static hcd() {
    var $this = this.le();
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
  static icd(message) {
    var $this = this.l(message);
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
  static jcd(message, cause) {
    var $this = this.ne(message, cause);
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
}
class UnknownFieldException extends SerializationException {
  static pcd(message) {
    var $this = this.icd(message);
    captureStack($this, $this.ocd_1);
    return $this;
  }
  static qcd(index) {
    return this.pcd('An unknown field for index ' + index);
  }
}
class MissingFieldException extends SerializationException {
  static xcd(missingFields, message, cause) {
    var $this = this.jcd(message, cause);
    captureStack($this, $this.wcd_1);
    $this.vcd_1 = missingFields;
    return $this;
  }
  static ycd(missingFields, serialName) {
    return this.xcd(missingFields, missingFields.e1() === 1 ? "Field '" + missingFields.d1(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
  }
}
class SerialDescriptor {}
function get_isNullable() {
  return false;
}
function get_isInline() {
  return false;
}
function get_annotations() {
  return emptyList();
}
class ContextDescriptor {
  constructor(original, kClass) {
    this.fce_1 = original;
    this.gce_1 = kClass;
    this.hce_1 = this.fce_1.ice() + '<' + this.gce_1.nf() + '>';
  }
  jce(index) {
    return this.fce_1.jce(index);
  }
  kce(name) {
    return this.fce_1.kce(name);
  }
  lce(index) {
    return this.fce_1.lce(index);
  }
  mce(index) {
    return this.fce_1.mce(index);
  }
  nce(index) {
    return this.fce_1.nce(index);
  }
  oce() {
    return this.fce_1.oce();
  }
  ece() {
    return this.fce_1.ece();
  }
  pce() {
    return this.fce_1.pce();
  }
  qce() {
    return this.fce_1.qce();
  }
  rce() {
    return this.fce_1.rce();
  }
  ice() {
    return this.hce_1;
  }
  equals(other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.fce_1, another.fce_1) && another.gce_1.equals(this.gce_1);
  }
  hashCode() {
    var result = this.gce_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.hce_1) | 0;
    return result;
  }
  toString() {
    return 'ContextDescriptor(kClass: ' + toString(this.gce_1) + ', original: ' + toString(this.fce_1) + ')';
  }
}
class elementDescriptors$1 {
  constructor($this_elementDescriptors) {
    this.wce_1 = $this_elementDescriptors;
    this.vce_1 = $this_elementDescriptors.qce();
  }
  b1() {
    return this.vce_1 > 0;
  }
  c1() {
    var tmp = this.wce_1.qce();
    var _unary__edvuaz = this.vce_1;
    this.vce_1 = _unary__edvuaz - 1 | 0;
    return this.wce_1.mce(tmp - _unary__edvuaz | 0);
  }
}
class _no_name_provided__qut3iv {
  constructor($this_elementDescriptors) {
    this.xce_1 = $this_elementDescriptors;
  }
  a1() {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
    return new elementDescriptors$1(this.xce_1);
  }
}
class elementNames$1 {
  constructor($this_elementNames) {
    this.zce_1 = $this_elementNames;
    this.yce_1 = $this_elementNames.qce();
  }
  b1() {
    return this.yce_1 > 0;
  }
  c1() {
    var tmp = this.zce_1.qce();
    var _unary__edvuaz = this.yce_1;
    this.yce_1 = _unary__edvuaz - 1 | 0;
    return this.zce_1.jce(tmp - _unary__edvuaz | 0);
  }
}
class _no_name_provided__qut3iv_0 {
  constructor($this_elementNames) {
    this.acf_1 = $this_elementNames;
  }
  a1() {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementNames>.<anonymous>' call
    return new elementNames$1(this.acf_1);
  }
}
class ClassSerialDescriptorBuilder {
  constructor(serialName) {
    this.mcc_1 = serialName;
    this.ncc_1 = false;
    this.occ_1 = emptyList();
    this.pcc_1 = ArrayList.i1();
    this.qcc_1 = HashSet.ta();
    this.rcc_1 = ArrayList.i1();
    this.scc_1 = ArrayList.i1();
    this.tcc_1 = ArrayList.i1();
  }
  bcf(elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.qcc_1.h(elementName)) {
      // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
      var message = "Element with name '" + elementName + "' is already registered in " + this.mcc_1;
      throw IllegalArgumentException.l(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.pcc_1.h(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.rcc_1.h(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.scc_1.h(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.tcc_1.h(isOptional);
  }
  ucc(elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.bcf(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.bcf.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  }
}
class CachedNames {}
class SerialDescriptorImpl {
  constructor(serialName, kind, elementsCount, typeParameters, builder) {
    this.ccf_1 = serialName;
    this.dcf_1 = kind;
    this.ecf_1 = elementsCount;
    this.fcf_1 = builder.occ_1;
    this.gcf_1 = toHashSet(builder.pcc_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.pcc_1;
    tmp.hcf_1 = copyToArray(this_0);
    this.icf_1 = compactArray(builder.rcc_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.scc_1;
    tmp_0.jcf_1 = copyToArray(this_1);
    this.kcf_1 = toBooleanArray(builder.tcc_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.hcf_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
      var tmp$ret$2 = to(item.nl_1, item.ml_1);
      destination.h(tmp$ret$2);
    }
    tmp_1.lcf_1 = toMap(destination);
    this.mcf_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.ncf_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  ice() {
    return this.ccf_1;
  }
  oce() {
    return this.dcf_1;
  }
  qce() {
    return this.ecf_1;
  }
  rce() {
    return this.fcf_1;
  }
  ocf() {
    return this.gcf_1;
  }
  jce(index) {
    return getChecked(this.hcf_1, index);
  }
  kce(name) {
    var tmp0_elvis_lhs = this.lcf_1.h3(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  lce(index) {
    return getChecked(this.jcf_1, index);
  }
  mce(index) {
    return getChecked(this.icf_1, index);
  }
  nce(index) {
    return getChecked_0(this.kcf_1, index);
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ice() === other.ice())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
      if (!contentEquals(this.mcf_1, other.mcf_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.qce() === other.qce())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.qce();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.mce(index).ice() === other.mce(index).ice())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.mce(index).oce(), other.mce(index).oce())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  hashCode() {
    return _get__hashCode__tgwhef(this);
  }
  toString() {
    var tmp = until(0, this.ecf_1);
    var tmp_0 = this.ccf_1 + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  }
}
class SerialKind {
  toString() {
    return ensureNotNull(getKClassFromExpression(this).nf());
  }
  hashCode() {
    return getStringHashCode(this.toString());
  }
}
class ENUM extends SerialKind {
  constructor() {
    ENUM_instance = null;
    super();
    ENUM_instance = this;
  }
}
class CONTEXTUAL extends SerialKind {
  constructor() {
    CONTEXTUAL_instance = null;
    super();
    CONTEXTUAL_instance = this;
  }
}
class PolymorphicKind extends SerialKind {}
class SEALED extends PolymorphicKind {
  constructor() {
    SEALED_instance = null;
    super();
    SEALED_instance = this;
  }
}
class OPEN extends PolymorphicKind {
  constructor() {
    OPEN_instance = null;
    super();
    OPEN_instance = this;
  }
}
class PrimitiveKind extends SerialKind {}
class BOOLEAN extends PrimitiveKind {
  constructor() {
    BOOLEAN_instance = null;
    super();
    BOOLEAN_instance = this;
  }
}
class BYTE extends PrimitiveKind {
  constructor() {
    BYTE_instance = null;
    super();
    BYTE_instance = this;
  }
}
class CHAR extends PrimitiveKind {
  constructor() {
    CHAR_instance = null;
    super();
    CHAR_instance = this;
  }
}
class SHORT extends PrimitiveKind {
  constructor() {
    SHORT_instance = null;
    super();
    SHORT_instance = this;
  }
}
class INT extends PrimitiveKind {
  constructor() {
    INT_instance = null;
    super();
    INT_instance = this;
  }
}
class LONG extends PrimitiveKind {
  constructor() {
    LONG_instance = null;
    super();
    LONG_instance = this;
  }
}
class FLOAT extends PrimitiveKind {
  constructor() {
    FLOAT_instance = null;
    super();
    FLOAT_instance = this;
  }
}
class DOUBLE extends PrimitiveKind {
  constructor() {
    DOUBLE_instance = null;
    super();
    DOUBLE_instance = this;
  }
}
class STRING extends PrimitiveKind {
  constructor() {
    STRING_instance = null;
    super();
    STRING_instance = this;
  }
}
class StructureKind extends SerialKind {}
class CLASS extends StructureKind {
  constructor() {
    CLASS_instance = null;
    super();
    CLASS_instance = this;
  }
}
class LIST extends StructureKind {
  constructor() {
    LIST_instance = null;
    super();
    LIST_instance = this;
  }
}
class MAP extends StructureKind {
  constructor() {
    MAP_instance = null;
    super();
    MAP_instance = this;
  }
}
class OBJECT extends StructureKind {
  constructor() {
    OBJECT_instance = null;
    super();
    OBJECT_instance = this;
  }
}
class Decoder {}
function decodeSerializableValue(deserializer) {
  return deserializer.lcc(this);
}
class CompositeDecoder {}
function decodeSequentially() {
  return false;
}
function decodeCollectionSize(descriptor) {
  return -1;
}
function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
  previousValue = previousValue === VOID ? null : previousValue;
  return $super === VOID ? this.rcg(descriptor, index, deserializer, previousValue) : $super.rcg.call(this, descriptor, index, deserializer, previousValue);
}
class AbstractDecoder {
  pcf() {
    throw SerializationException.icd(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  }
  qcf() {
    return true;
  }
  rcf() {
    return null;
  }
  scf() {
    var tmp = this.pcf();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  }
  tcf() {
    var tmp = this.pcf();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  ucf() {
    var tmp = this.pcf();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  vcf() {
    var tmp = this.pcf();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  wcf() {
    var tmp = this.pcf();
    return tmp instanceof Long ? tmp : THROW_CCE();
  }
  xcf() {
    var tmp = this.pcf();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  ycf() {
    var tmp = this.pcf();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  zcf() {
    var tmp = this.pcf();
    return tmp instanceof Char ? tmp.n2_1 : THROW_CCE();
  }
  acg() {
    var tmp = this.pcf();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  }
  bcg(enumDescriptor) {
    var tmp = this.pcf();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  ccg(descriptor) {
    return this;
  }
  dcg(deserializer, previousValue) {
    return this.ecg(deserializer);
  }
  fcg(descriptor) {
    return this;
  }
  gcg(descriptor) {
  }
  hcg(descriptor, index) {
    return this.scf();
  }
  icg(descriptor, index) {
    return this.tcf();
  }
  jcg(descriptor, index) {
    return this.ucf();
  }
  kcg(descriptor, index) {
    return this.vcf();
  }
  lcg(descriptor, index) {
    return this.wcf();
  }
  mcg(descriptor, index) {
    return this.xcf();
  }
  ncg(descriptor, index) {
    return this.ycf();
  }
  ocg(descriptor, index) {
    return this.zcf();
  }
  pcg(descriptor, index) {
    return this.acg();
  }
  qcg(descriptor, index) {
    return this.ccg(descriptor.mce(index));
  }
  rcg(descriptor, index, deserializer, previousValue) {
    return this.dcg(deserializer, previousValue);
  }
  tcg(descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = deserializer.jcc().ece();
    var tmp;
    if (isNullabilitySupported || this.qcf()) {
      // Inline function 'kotlinx.serialization.encoding.AbstractDecoder.decodeNullableSerializableElement.<anonymous>' call
      tmp = this.dcg(deserializer, previousValue);
    } else {
      tmp = this.rcf();
    }
    return tmp;
  }
}
class Encoder {}
function encodeNotNullMark() {
}
function beginCollection(descriptor, collectionSize) {
  return this.fcg(descriptor);
}
function encodeSerializableValue(serializer, value) {
  serializer.kcc(this, value);
}
function encodeNullableSerializableValue(serializer, value) {
  var isNullabilitySupported = serializer.jcc().ece();
  if (isNullabilitySupported) {
    return this.ych(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
  }
  if (value == null) {
    this.bch();
  } else {
    this.bci();
    this.ych(serializer, value);
  }
}
class CompositeEncoder {}
function shouldEncodeElementDefault(descriptor, index) {
  return true;
}
class AbstractEncoder {
  static ycg() {
    return createThis(this);
  }
  fcg(descriptor) {
    return this;
  }
  gcg(descriptor) {
  }
  zcg(descriptor, index) {
    return true;
  }
  ach(value) {
    throw SerializationException.icd('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
  }
  bch() {
    throw SerializationException.icd("'null' is not supported by default");
  }
  cch(value) {
    return this.ach(value);
  }
  dch(value) {
    return this.ach(value);
  }
  ech(value) {
    return this.ach(value);
  }
  fch(value) {
    return this.ach(value);
  }
  gch(value) {
    return this.ach(value);
  }
  hch(value) {
    return this.ach(value);
  }
  ich(value) {
    return this.ach(value);
  }
  jch(value) {
    return this.ach(new Char(value));
  }
  kch(value) {
    return this.ach(value);
  }
  lch(enumDescriptor, index) {
    return this.ach(index);
  }
  mch(descriptor) {
    return this;
  }
  nch(descriptor, index, value) {
    if (this.zcg(descriptor, index)) {
      this.cch(value);
    }
  }
  och(descriptor, index, value) {
    if (this.zcg(descriptor, index)) {
      this.dch(value);
    }
  }
  pch(descriptor, index, value) {
    if (this.zcg(descriptor, index)) {
      this.ech(value);
    }
  }
  qch(descriptor, index, value) {
    if (this.zcg(descriptor, index)) {
      this.fch(value);
    }
  }
  rch(descriptor, index, value) {
    if (this.zcg(descriptor, index)) {
      this.gch(value);
    }
  }
  sch(descriptor, index, value) {
    if (this.zcg(descriptor, index)) {
      this.hch(value);
    }
  }
  tch(descriptor, index, value) {
    if (this.zcg(descriptor, index)) {
      this.ich(value);
    }
  }
  uch(descriptor, index, value) {
    if (this.zcg(descriptor, index)) {
      this.jch(value);
    }
  }
  vch(descriptor, index, value) {
    if (this.zcg(descriptor, index)) {
      this.kch(value);
    }
  }
  wch(descriptor, index) {
    return this.zcg(descriptor, index) ? this.mch(descriptor.mce(index)) : NoOpEncoder_getInstance();
  }
  xch(descriptor, index, serializer, value) {
    if (this.zcg(descriptor, index)) {
      this.ych(serializer, value);
    }
  }
  zch(descriptor, index, serializer, value) {
    if (this.zcg(descriptor, index)) {
      this.aci(serializer, value);
    }
  }
}
class NothingSerializer {
  constructor() {
    NothingSerializer_instance = this;
    this.gci_1 = NothingSerialDescriptor_getInstance();
  }
  jcc() {
    return this.gci_1;
  }
  hci(encoder, value) {
    throw SerializationException.icd("'kotlin.Nothing' cannot be serialized");
  }
  kcc(encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.hci(encoder, tmp);
  }
  lcc(decoder) {
    throw SerializationException.icd("'kotlin.Nothing' does not have instances");
  }
}
class DurationSerializer {
  constructor() {
    DurationSerializer_instance = this;
    this.ici_1 = new PrimitiveSerialDescriptor('kotlin.time.Duration', STRING_getInstance());
  }
  jcc() {
    return this.ici_1;
  }
  jci(encoder, value) {
    encoder.kch(Duration__toIsoString_impl_9h6wsm(value));
  }
  kcc(encoder, value) {
    return this.jci(encoder, value instanceof Duration ? value.xj_1 : THROW_CCE());
  }
  kci(decoder) {
    return Companion_getInstance().fs(decoder.acg());
  }
  lcc(decoder) {
    return new Duration(this.kci(decoder));
  }
}
class ListLikeDescriptor {
  constructor(elementDescriptor) {
    this.nci_1 = elementDescriptor;
    this.oci_1 = 1;
  }
  oce() {
    return LIST_getInstance();
  }
  qce() {
    return this.oci_1;
  }
  jce(index) {
    return index.toString();
  }
  kce(name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  nce(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ice() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return false;
  }
  lce(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ice() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return emptyList();
  }
  mce(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ice() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return this.nci_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.nci_1, other.nci_1) && this.ice() === other.ice())
      return true;
    return false;
  }
  hashCode() {
    return imul(hashCode(this.nci_1), 31) + getStringHashCode(this.ice()) | 0;
  }
  toString() {
    return this.ice() + '(' + toString(this.nci_1) + ')';
  }
}
class ArrayListClassDesc extends ListLikeDescriptor {
  ice() {
    return 'kotlin.collections.ArrayList';
  }
}
class HashSetClassDesc extends ListLikeDescriptor {
  ice() {
    return 'kotlin.collections.HashSet';
  }
}
class LinkedHashSetClassDesc extends ListLikeDescriptor {
  ice() {
    return 'kotlin.collections.LinkedHashSet';
  }
}
class MapLikeDescriptor {
  constructor(serialName, keyDescriptor, valueDescriptor) {
    this.tci_1 = serialName;
    this.uci_1 = keyDescriptor;
    this.vci_1 = valueDescriptor;
    this.wci_1 = 2;
  }
  ice() {
    return this.tci_1;
  }
  oce() {
    return MAP_getInstance();
  }
  qce() {
    return this.wci_1;
  }
  jce(index) {
    return index.toString();
  }
  kce(name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  nce(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ice() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return false;
  }
  lce(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ice() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return emptyList();
  }
  mce(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.ice() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.uci_1;
        break;
      case 1:
        tmp = this.vci_1;
        break;
      default:
        var message_0 = 'Unreached';
        throw IllegalStateException.l5(toString(message_0));
    }
    return tmp;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.ice() === other.ice()))
      return false;
    if (!equals(this.uci_1, other.uci_1))
      return false;
    if (!equals(this.vci_1, other.vci_1))
      return false;
    return true;
  }
  hashCode() {
    var result = getStringHashCode(this.ice());
    result = imul(31, result) + hashCode(this.uci_1) | 0;
    result = imul(31, result) + hashCode(this.vci_1) | 0;
    return result;
  }
  toString() {
    return this.ice() + '(' + toString(this.uci_1) + ', ' + toString(this.vci_1) + ')';
  }
}
class HashMapClassDesc extends MapLikeDescriptor {
  constructor(keyDesc, valueDesc) {
    super('kotlin.collections.HashMap', keyDesc, valueDesc);
  }
}
class LinkedHashMapClassDesc extends MapLikeDescriptor {
  constructor(keyDesc, valueDesc) {
    super('kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
}
class ArrayClassDesc extends ListLikeDescriptor {
  ice() {
    return 'kotlin.Array';
  }
}
class PrimitiveArrayDescriptor extends ListLikeDescriptor {
  constructor(primitive) {
    super(primitive);
    this.bcj_1 = primitive.ice() + 'Array';
  }
  ice() {
    return this.bcj_1;
  }
}
class AbstractCollectionSerializer {
  xcj(decoder, previous) {
    var tmp0_elvis_lhs = previous == null ? null : this.kcj(previous);
    var builder = tmp0_elvis_lhs == null ? this.ecj() : tmp0_elvis_lhs;
    var startIndex = this.gcj(builder);
    var compositeDecoder = decoder.fcg(this.jcc());
    if (compositeDecoder.vcg()) {
      this.ucj(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.wcg(this.jcc());
        if (index === -1)
          break $l$loop;
        this.wcj(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.gcg(this.jcc());
    return this.icj(builder);
  }
  lcc(decoder) {
    return this.xcj(decoder, null);
  }
  wcj(decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.vcj(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.vcj.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  }
}
class CollectionLikeSerializer extends AbstractCollectionSerializer {
  constructor(elementSerializer) {
    super();
    this.scj_1 = elementSerializer;
  }
  tcj(encoder, value) {
    var size = this.pck(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.jcc();
    var composite = encoder.cci(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
    var iterator = this.rck(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.xch(this.jcc(), index, this.scj_1, iterator.c1());
      }
       while (inductionVariable < size);
    composite.gcg(descriptor);
  }
  kcc(encoder, value) {
    return this.tcj(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  ucj(decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException.l(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.vcj(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  }
  vcj(decoder, index, builder, checkIndex) {
    this.ocj(builder, index, decoder.scg(this.jcc(), index, this.scj_1));
  }
}
class CollectionSerializer extends CollectionLikeSerializer {
  qcj(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  pck(_this__u8e3s4) {
    return this.qcj((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  rcj(_this__u8e3s4) {
    return _this__u8e3s4.a1();
  }
  rck(_this__u8e3s4) {
    return this.rcj((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  }
}
class ArrayListSerializer extends CollectionSerializer {
  constructor(element) {
    super(element);
    this.dcj_1 = new ArrayListClassDesc(element.jcc());
  }
  jcc() {
    return this.dcj_1;
  }
  ecj() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList.i1();
  }
  fcj(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  gcj(_this__u8e3s4) {
    return this.fcj(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  hcj(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  icj(_this__u8e3s4) {
    return this.hcj(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  jcj(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList.v(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  kcj(_this__u8e3s4) {
    return this.jcj((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  lcj(_this__u8e3s4, size) {
    return _this__u8e3s4.l8(size);
  }
  mcj(_this__u8e3s4, size) {
    return this.lcj(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  }
  ncj(_this__u8e3s4, index, element) {
    _this__u8e3s4.q3(index, element);
  }
  ocj(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.ncj(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class HashSetSerializer extends CollectionSerializer {
  constructor(eSerializer) {
    super(eSerializer);
    this.zcj_1 = new HashSetClassDesc(eSerializer.jcc());
  }
  jcc() {
    return this.zcj_1;
  }
  ecj() {
    return HashSet.ta();
  }
  ack(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  gcj(_this__u8e3s4) {
    return this.ack(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  }
  bck(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  icj(_this__u8e3s4) {
    return this.bck(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  }
  cck(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet.ua(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  kcj(_this__u8e3s4) {
    return this.cck((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  dck(_this__u8e3s4, size) {
  }
  mcj(_this__u8e3s4, size) {
    return this.dck(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  }
  eck(_this__u8e3s4, index, element) {
    _this__u8e3s4.h(element);
  }
  ocj(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
    return this.eck(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class LinkedHashSetSerializer extends CollectionSerializer {
  constructor(eSerializer) {
    super(eSerializer);
    this.gck_1 = new LinkedHashSetClassDesc(eSerializer.jcc());
  }
  jcc() {
    return this.gck_1;
  }
  ecj() {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet.h1();
  }
  hck(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  gcj(_this__u8e3s4) {
    return this.hck(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  }
  ick(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  icj(_this__u8e3s4) {
    return this.ick(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  }
  cck(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet.j1(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  kcj(_this__u8e3s4) {
    return this.cck((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  jck(_this__u8e3s4, size) {
  }
  mcj(_this__u8e3s4, size) {
    return this.jck(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  }
  kck(_this__u8e3s4, index, element) {
    _this__u8e3s4.h(element);
  }
  ocj(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
    return this.kck(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class MapLikeSerializer extends AbstractCollectionSerializer {
  constructor(keySerializer, valueSerializer) {
    super();
    this.wck_1 = keySerializer;
    this.xck_1 = valueSerializer;
  }
  yck(decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException.l(toString(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.d2_1;
    var last = progression.e2_1;
    var step_0 = progression.f2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.zck(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  }
  ucj(decoder, builder, startIndex, size) {
    return this.yck(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  }
  zck(decoder, index, builder, checkIndex) {
    var key = decoder.scg(this.jcc(), index, this.wck_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.wcg(this.jcc());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this_0 === (index + 1 | 0))) {
        // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>.<anonymous>' call
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException.l(toString(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.f3(key)) {
      var tmp_2 = this.xck_1.jcc().oce();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.rcg(this.jcc(), vIndex, this.xck_1, getValue(builder, key));
    } else {
      tmp_0 = decoder.scg(this.jcc(), vIndex, this.xck_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.j3(key, value);
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.zck(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  }
  tcj(encoder, value) {
    var size = this.pck(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.jcc();
    var composite = encoder.cci(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>' call
    var iterator = this.rck(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = iterator;
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.t1();
      // Inline function 'kotlin.collections.component2' call
      var v = element.u1();
      var tmp = this.jcc();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      composite.xch(tmp, _unary__edvuaz, this.wck_1, k);
      var tmp_0 = this.jcc();
      var _unary__edvuaz_0 = index;
      index = _unary__edvuaz_0 + 1 | 0;
      composite.xch(tmp_0, _unary__edvuaz_0, this.xck_1, v);
    }
    composite.gcg(descriptor);
  }
  kcc(encoder, value) {
    return this.tcj(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
}
class HashMapSerializer extends MapLikeSerializer {
  constructor(kSerializer, vSerializer) {
    super(kSerializer, vSerializer);
    this.nck_1 = new HashMapClassDesc(kSerializer.jcc(), vSerializer.jcc());
  }
  jcc() {
    return this.nck_1;
  }
  ock(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  pck(_this__u8e3s4) {
    return this.ock((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  qck(_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.s1().a1();
  }
  rck(_this__u8e3s4) {
    return this.qck((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  ecj() {
    return HashMap.y8();
  }
  sck(_this__u8e3s4) {
    return imul(_this__u8e3s4.e1(), 2);
  }
  gcj(_this__u8e3s4) {
    return this.sck(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  }
  tck(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  icj(_this__u8e3s4) {
    return this.tck(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  }
  uck(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap.n9(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  kcj(_this__u8e3s4) {
    return this.uck((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  vck(_this__u8e3s4, size) {
  }
  mcj(_this__u8e3s4, size) {
    return this.vck(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  }
}
class LinkedHashMapSerializer extends MapLikeSerializer {
  constructor(kSerializer, vSerializer) {
    super(kSerializer, vSerializer);
    this.ccl_1 = new LinkedHashMapClassDesc(kSerializer.jcc(), vSerializer.jcc());
  }
  jcc() {
    return this.ccl_1;
  }
  ock(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  pck(_this__u8e3s4) {
    return this.ock((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  qck(_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.s1().a1();
  }
  rck(_this__u8e3s4) {
    return this.qck((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  ecj() {
    return LinkedHashMap.rc();
  }
  dcl(_this__u8e3s4) {
    return imul(_this__u8e3s4.e1(), 2);
  }
  gcj(_this__u8e3s4) {
    return this.dcl(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  }
  ecl(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  icj(_this__u8e3s4) {
    return this.ecl(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  }
  uck(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap.tc(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  kcj(_this__u8e3s4) {
    return this.uck((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  fcl(_this__u8e3s4, size) {
  }
  mcj(_this__u8e3s4, size) {
    return this.fcl(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  }
}
class ReferenceArraySerializer extends CollectionLikeSerializer {
  constructor(kClass, eSerializer) {
    super(eSerializer);
    this.hcl_1 = kClass;
    this.icl_1 = new ArrayClassDesc(eSerializer.jcc());
  }
  jcc() {
    return this.icl_1;
  }
  jcl(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  pck(_this__u8e3s4) {
    return this.jcl((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  kcl(_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  }
  rck(_this__u8e3s4) {
    return this.kcl((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  ecj() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList.i1();
  }
  lcl(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  gcj(_this__u8e3s4) {
    return this.lcl(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  mcl(_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.hcl_1);
  }
  icj(_this__u8e3s4) {
    return this.mcl(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  ncl(_this__u8e3s4) {
    return ArrayList.v(asList(_this__u8e3s4));
  }
  kcj(_this__u8e3s4) {
    return this.ncl((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  ocl(_this__u8e3s4, size) {
    return _this__u8e3s4.l8(size);
  }
  mcj(_this__u8e3s4, size) {
    return this.ocl(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  }
  pcl(_this__u8e3s4, index, element) {
    _this__u8e3s4.q3(index, element);
  }
  ocj(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.pcl(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class PrimitiveArraySerializer extends CollectionLikeSerializer {
  constructor(primitiveSerializer) {
    super(primitiveSerializer);
    this.rcl_1 = new PrimitiveArrayDescriptor(primitiveSerializer.jcc());
  }
  jcc() {
    return this.rcl_1;
  }
  scl(_this__u8e3s4) {
    return _this__u8e3s4.tcl();
  }
  gcj(_this__u8e3s4) {
    return this.scl(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  }
  ucl(_this__u8e3s4) {
    return _this__u8e3s4.vcl();
  }
  icj(_this__u8e3s4) {
    return this.ucl(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  }
  wcl(_this__u8e3s4, size) {
    return _this__u8e3s4.xcl(size);
  }
  mcj(_this__u8e3s4, size) {
    return this.wcl(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  }
  ycl(_this__u8e3s4) {
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException.l5(toString(message));
  }
  rck(_this__u8e3s4) {
    return this.ycl((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
  }
  zcl(_this__u8e3s4, index, element) {
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException.l5(toString(message));
  }
  ocj(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
    return this.zcl(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  ecj() {
    return this.kcj(this.acm());
  }
  dcm(encoder, value) {
    var size = this.pck(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.rcl_1;
    var composite = encoder.cci(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
    this.ccm(composite, value, size);
    composite.gcg(descriptor);
  }
  kcc(encoder, value) {
    return this.dcm(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  tcj(encoder, value) {
    return this.dcm(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  lcc(decoder) {
    return this.xcj(decoder, null);
  }
}
class PrimitiveArrayBuilder {
  ecm(requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.tcl() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.xcl(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.xcl.call(this, requiredCapacity);
    }
    return tmp;
  }
}
class Companion {
  constructor() {
    Companion_instance_0 = this;
    this.fcm_1 = longArray(0);
  }
}
class ElementMarker {
  constructor(descriptor, readIfAbsent) {
    Companion_getInstance_6();
    this.gcm_1 = descriptor;
    this.hcm_1 = readIfAbsent;
    var elementsCount = this.gcm_1.qce();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = (new Long(-1, -1)).i4(elementsCount);
      }
      tmp.icm_1 = tmp_0;
      this.jcm_1 = Companion_getInstance_6().fcm_1;
    } else {
      this.icm_1 = new Long(0, 0);
      this.jcm_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  kcm(index) {
    if (index < 64) {
      this.icm_1 = this.icm_1.m4((new Long(1, 0)).i4(index));
    } else {
      markHigh(this, index);
    }
  }
  lcm() {
    var elementsCount = this.gcm_1.qce();
    while (!this.icm_1.equals(new Long(-1, -1))) {
      var index = countTrailingZeroBits(this.icm_1.h4());
      this.icm_1 = this.icm_1.m4((new Long(1, 0)).i4(index));
      if (this.hcm_1(this.gcm_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  }
}
class EnumSerializer {
  constructor(serialName, values) {
    this.mcm_1 = values;
    this.ncm_1 = null;
    var tmp = this;
    tmp.ocm_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
  }
  jcc() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.ocm_1;
    descriptor$factory_1();
    return this_0.u1();
  }
  ccn(encoder, value) {
    var index = indexOf(this.mcm_1, value);
    if (index === -1) {
      throw SerializationException.icd(toString(value) + ' is not a valid enum ' + this.jcc().ice() + ', ' + ('must be one of ' + contentToString(this.mcm_1)));
    }
    encoder.lch(this.jcc(), index);
  }
  kcc(encoder, value) {
    return this.ccn(encoder, value instanceof Enum ? value : THROW_CCE());
  }
  lcc(decoder) {
    var index = decoder.bcg(this.jcc());
    if (!(0 <= index ? index <= (this.mcm_1.length - 1 | 0) : false)) {
      throw SerializationException.icd('' + index + ' is not among valid ' + this.jcc().ice() + ' enum values, ' + ('values size is ' + this.mcm_1.length));
    }
    return this.mcm_1[index];
  }
  toString() {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.jcc().ice() + '>';
  }
}
class PluginGeneratedSerialDescriptor {
  constructor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.pcm_1 = serialName;
    this.qcm_1 = generatedSerializer;
    this.rcm_1 = elementsCount;
    this.scm_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.rcm_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.tcm_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.rcm_1;
    tmp_3.ucm_1 = fillArrayVal(Array(size), null);
    this.vcm_1 = null;
    this.wcm_1 = booleanArray(this.rcm_1);
    this.xcm_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.ycm_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.zcm_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.acn_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  ice() {
    return this.pcm_1;
  }
  qce() {
    return this.rcm_1;
  }
  oce() {
    return CLASS_getInstance();
  }
  rce() {
    var tmp0_elvis_lhs = this.vcm_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  ocf() {
    return this.xcm_1.i3();
  }
  rcn() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.zcm_1;
    typeParameterDescriptors$factory();
    return this_0.u1();
  }
  scn(name, isOptional) {
    this.scm_1 = this.scm_1 + 1 | 0;
    this.tcm_1[this.scm_1] = name;
    this.wcm_1[this.scm_1] = isOptional;
    this.ucm_1[this.scm_1] = null;
    if (this.scm_1 === (this.rcm_1 - 1 | 0)) {
      this.xcm_1 = buildIndices(this);
    }
  }
  bcn(name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.scn(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.scn.call(this, name, isOptional);
    }
    return tmp;
  }
  mce(index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).jcc();
  }
  nce(index) {
    return getChecked_0(this.wcm_1, index);
  }
  lce(index) {
    var tmp0_elvis_lhs = getChecked(this.ucm_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  jce(index) {
    return getChecked(this.tcm_1, index);
  }
  kce(name) {
    var tmp0_elvis_lhs = this.xcm_1.h3(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ice() === other.ice())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
      if (!contentEquals(this.rcn(), other.rcn())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.qce() === other.qce())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.qce();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.mce(index).ice() === other.mce(index).ice())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.mce(index).oce(), other.mce(index).oce())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  hashCode() {
    return _get__hashCode__tgwhef_0(this);
  }
  toString() {
    var tmp = until(0, this.rcm_1);
    var tmp_0 = this.ice() + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  }
}
class EnumDescriptor extends PluginGeneratedSerialDescriptor {
  constructor(name, elementsCount) {
    super(name, VOID, elementsCount);
    this.pcn_1 = ENUM_getInstance();
    var tmp = this;
    tmp.qcn_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  oce() {
    return this.pcn_1;
  }
  mce(index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
      return false;
    if (!(other.oce() === ENUM_getInstance()))
      return false;
    if (!(this.ice() === other.ice()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  }
  toString() {
    return joinToString(get_elementNames(this), ', ', this.ice() + '(', ')');
  }
  hashCode() {
    var result = getStringHashCode(this.ice());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var tmp0_iterator = get_elementNames(this).a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.EnumDescriptor.hashCode.<anonymous>' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  }
}
class InlineClassDescriptor extends PluginGeneratedSerialDescriptor {
  constructor(name, generatedSerializer) {
    super(name, generatedSerializer, 1);
    this.fco_1 = true;
  }
  pce() {
    return this.fco_1;
  }
  hashCode() {
    return imul(super.hashCode(), 31);
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ice() === other.ice())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.InlineClassDescriptor.equals.<anonymous>' call
      if (!(other.fco_1 && contentEquals(this.rcn(), other.rcn()))) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.qce() === other.qce())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.qce();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.mce(index).ice() === other.mce(index).ice())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.mce(index).oce(), other.mce(index).oce())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
}
class GeneratedSerializer {}
function typeParametersSerializers() {
  return get_EMPTY_SERIALIZER_ARRAY();
}
class InlinePrimitiveDescriptor$1 {
  constructor($primitiveSerializer) {
    this.gco_1 = $primitiveSerializer;
  }
  hco() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.gco_1];
  }
  jcc() {
    var message = 'unsupported';
    throw IllegalStateException.l5(toString(message));
  }
  kcc(encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException.l5(toString(message));
  }
  lcc(decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException.l5(toString(message));
  }
}
class NoOpEncoder extends AbstractEncoder {
  static kco() {
    NoOpEncoder_instance = null;
    var $this = this.ycg();
    NoOpEncoder_instance = $this;
    $this.jco_1 = EmptySerializersModule_0();
    return $this;
  }
  ucg() {
    return this.jco_1;
  }
  ach(value) {
    return Unit_instance;
  }
  bch() {
    return Unit_instance;
  }
  cch(value) {
    return Unit_instance;
  }
  dch(value) {
    return Unit_instance;
  }
  ech(value) {
    return Unit_instance;
  }
  fch(value) {
    return Unit_instance;
  }
  gch(value) {
    return Unit_instance;
  }
  hch(value) {
    return Unit_instance;
  }
  ich(value) {
    return Unit_instance;
  }
  jch(value) {
    return Unit_instance;
  }
  kch(value) {
    return Unit_instance;
  }
  lch(enumDescriptor, index) {
    return Unit_instance;
  }
}
class NothingSerialDescriptor {
  constructor() {
    NothingSerialDescriptor_instance = this;
    this.lco_1 = OBJECT_getInstance();
    this.mco_1 = 'kotlin.Nothing';
  }
  oce() {
    return this.lco_1;
  }
  ice() {
    return this.mco_1;
  }
  qce() {
    return 0;
  }
  jce(index) {
    error(this);
  }
  kce(name) {
    error(this);
  }
  nce(index) {
    error(this);
  }
  mce(index) {
    error(this);
  }
  lce(index) {
    error(this);
  }
  toString() {
    return 'NothingSerialDescriptor';
  }
  equals(other) {
    return this === other;
  }
  hashCode() {
    return getStringHashCode(this.mco_1) + imul(31, this.lco_1.hashCode()) | 0;
  }
}
class NullableSerializer {
  constructor(serializer) {
    this.nco_1 = serializer;
    this.oco_1 = new SerialDescriptorForNullable(this.nco_1.jcc());
  }
  jcc() {
    return this.oco_1;
  }
  pco(encoder, value) {
    if (!(value == null)) {
      encoder.bci();
      encoder.ych(this.nco_1, value);
    } else {
      encoder.bch();
    }
  }
  kcc(encoder, value) {
    return this.pco(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  lcc(decoder) {
    return decoder.qcf() ? decoder.ecg(this.nco_1) : decoder.rcf();
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.nco_1, other.nco_1))
      return false;
    return true;
  }
  hashCode() {
    return hashCode(this.nco_1);
  }
}
class SerialDescriptorForNullable {
  constructor(original) {
    this.sce_1 = original;
    this.tce_1 = this.sce_1.ice() + '?';
    this.uce_1 = cachedSerialNames(this.sce_1);
  }
  jce(index) {
    return this.sce_1.jce(index);
  }
  kce(name) {
    return this.sce_1.kce(name);
  }
  lce(index) {
    return this.sce_1.lce(index);
  }
  mce(index) {
    return this.sce_1.mce(index);
  }
  nce(index) {
    return this.sce_1.nce(index);
  }
  oce() {
    return this.sce_1.oce();
  }
  pce() {
    return this.sce_1.pce();
  }
  qce() {
    return this.sce_1.qce();
  }
  rce() {
    return this.sce_1.rce();
  }
  ice() {
    return this.tce_1;
  }
  ocf() {
    return this.uce_1;
  }
  ece() {
    return true;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.sce_1, other.sce_1))
      return false;
    return true;
  }
  toString() {
    return toString(this.sce_1) + '?';
  }
  hashCode() {
    return imul(hashCode(this.sce_1), 31);
  }
}
class ObjectSerializer {
  constructor(serialName, objectInstance) {
    this.qco_1 = objectInstance;
    this.rco_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.sco_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
  }
  jcc() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.sco_1;
    descriptor$factory_2();
    return this_0.u1();
  }
  zcc(encoder, value) {
    encoder.fcg(this.jcc()).gcg(this.jcc());
  }
  kcc(encoder, value) {
    return this.zcc(encoder, !(value == null) ? value : THROW_CCE());
  }
  lcc(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.jcc();
    var composite = decoder.fcg(descriptor);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.internal.ObjectSerializer.deserialize.<anonymous>' call
      if (composite.vcg()) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.wcg(this.jcc());
      if (index === -1) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else
        throw SerializationException.icd('Unexpected index ' + index);
    }
    var result = tmp$ret$0;
    composite.gcg(descriptor);
    return this.qco_1;
  }
}
class SerializerFactory {}
class CharArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    CharArraySerializer_instance = null;
    super(serializer_1(Companion_getInstance_0()));
    CharArraySerializer_instance = this;
  }
  wco(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  pck(_this__u8e3s4) {
    return this.wco((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  xco(_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.xco((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  acm() {
    return charArray(0);
  }
  yco(decoder, index, builder, checkIndex) {
    builder.bcp(decoder.ocg(this.rcl_1, index));
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.yco(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.yco(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  ccp(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.uch(this.rcl_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.ccp(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class DoubleArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    DoubleArraySerializer_instance = null;
    super(serializer_2(DoubleCompanionObject_instance));
    DoubleArraySerializer_instance = this;
  }
  fcp(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  pck(_this__u8e3s4) {
    return this.fcp((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  gcp(_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.gcp((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  acm() {
    return new Float64Array(0);
  }
  hcp(decoder, index, builder, checkIndex) {
    builder.kcp(decoder.ncg(this.rcl_1, index));
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.hcp(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.hcp(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  lcp(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.tch(this.rcl_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.lcp(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class FloatArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    FloatArraySerializer_instance = null;
    super(serializer_3(FloatCompanionObject_instance));
    FloatArraySerializer_instance = this;
  }
  ocp(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  pck(_this__u8e3s4) {
    return this.ocp((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  pcp(_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.pcp((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  acm() {
    return new Float32Array(0);
  }
  qcp(decoder, index, builder, checkIndex) {
    builder.tcp(decoder.mcg(this.rcl_1, index));
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.qcp(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.qcp(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  ucp(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.sch(this.rcl_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.ucp(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class LongArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    LongArraySerializer_instance = null;
    super(serializer_4(Companion_getInstance_1()));
    LongArraySerializer_instance = this;
  }
  xcp(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  pck(_this__u8e3s4) {
    return this.xcp((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  ycp(_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.ycp((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  acm() {
    return longArray(0);
  }
  zcp(decoder, index, builder, checkIndex) {
    builder.ccq(decoder.lcg(this.rcl_1, index));
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.zcp(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.zcp(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  dcq(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.rch(this.rcl_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.dcq(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class ULongArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ULongArraySerializer_instance = null;
    super(serializer_5(Companion_getInstance_2()));
    ULongArraySerializer_instance = this;
  }
  gcq(_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  }
  pck(_this__u8e3s4) {
    return this.gcq(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.e5_1 : THROW_CCE());
  }
  hcq(_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.hcq(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.e5_1 : THROW_CCE());
  }
  icq() {
    return _ULongArray___init__impl__twm1l3(0);
  }
  acm() {
    return new ULongArray(this.icq());
  }
  jcq(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.qcg(this.rcl_1, index).wcf();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.mcq(tmp$ret$0);
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.jcq(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.jcq(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  ncq(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.wch(this.rcl_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.gch(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.ncq(encoder, content instanceof ULongArray ? content.e5_1 : THROW_CCE(), size);
  }
}
class IntArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    IntArraySerializer_instance = null;
    super(serializer_6(IntCompanionObject_instance));
    IntArraySerializer_instance = this;
  }
  qcq(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  pck(_this__u8e3s4) {
    return this.qcq((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  rcq(_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.rcq((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  acm() {
    return new Int32Array(0);
  }
  scq(decoder, index, builder, checkIndex) {
    builder.vcq(decoder.kcg(this.rcl_1, index));
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.scq(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.scq(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  wcq(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.qch(this.rcl_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.wcq(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class UIntArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    UIntArraySerializer_instance = null;
    super(serializer_7(Companion_getInstance_3()));
    UIntArraySerializer_instance = this;
  }
  zcq(_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  }
  pck(_this__u8e3s4) {
    return this.zcq(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.f5_1 : THROW_CCE());
  }
  acr(_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.acr(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.f5_1 : THROW_CCE());
  }
  bcr() {
    return _UIntArray___init__impl__ghjpc6(0);
  }
  acm() {
    return new UIntArray(this.bcr());
  }
  ccr(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.qcg(this.rcl_1, index).vcf();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.fcr(tmp$ret$0);
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.ccr(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.ccr(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  gcr(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.wch(this.rcl_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.fch(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.gcr(encoder, content instanceof UIntArray ? content.f5_1 : THROW_CCE(), size);
  }
}
class ShortArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ShortArraySerializer_instance = null;
    super(serializer_8(ShortCompanionObject_instance));
    ShortArraySerializer_instance = this;
  }
  jcr(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  pck(_this__u8e3s4) {
    return this.jcr((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  kcr(_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.kcr((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  acm() {
    return new Int16Array(0);
  }
  lcr(decoder, index, builder, checkIndex) {
    builder.ocr(decoder.jcg(this.rcl_1, index));
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.lcr(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.lcr(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  pcr(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.pch(this.rcl_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.pcr(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class UShortArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    UShortArraySerializer_instance = null;
    super(serializer_9(Companion_getInstance_4()));
    UShortArraySerializer_instance = this;
  }
  scr(_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  }
  pck(_this__u8e3s4) {
    return this.scr(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.g5_1 : THROW_CCE());
  }
  tcr(_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.tcr(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.g5_1 : THROW_CCE());
  }
  ucr() {
    return _UShortArray___init__impl__9b26ef(0);
  }
  acm() {
    return new UShortArray(this.ucr());
  }
  vcr(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.qcg(this.rcl_1, index).ucf();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.ycr(tmp$ret$0);
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.vcr(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.vcr(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  zcr(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.wch(this.rcl_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.ech(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.zcr(encoder, content instanceof UShortArray ? content.g5_1 : THROW_CCE(), size);
  }
}
class ByteArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ByteArraySerializer_instance = null;
    super(serializer_10(ByteCompanionObject_instance));
    ByteArraySerializer_instance = this;
  }
  ccs(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  pck(_this__u8e3s4) {
    return this.ccs((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  dcs(_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.dcs((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  acm() {
    return new Int8Array(0);
  }
  ecs(decoder, index, builder, checkIndex) {
    builder.hcs(decoder.icg(this.rcl_1, index));
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.ecs(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.ecs(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  ics(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.och(this.rcl_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.ics(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class UByteArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    UByteArraySerializer_instance = null;
    super(serializer_11(Companion_getInstance_5()));
    UByteArraySerializer_instance = this;
  }
  lcs(_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  }
  pck(_this__u8e3s4) {
    return this.lcs(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.h5_1 : THROW_CCE());
  }
  mcs(_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.mcs(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.h5_1 : THROW_CCE());
  }
  ncs() {
    return _UByteArray___init__impl__ip4y9n(0);
  }
  acm() {
    return new UByteArray(this.ncs());
  }
  ocs(decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.qcg(this.rcl_1, index).tcf();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.rcs(tmp$ret$0);
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.ocs(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.ocs(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  scs(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.wch(this.rcl_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.dch(tmp$ret$0);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.scs(encoder, content instanceof UByteArray ? content.h5_1 : THROW_CCE(), size);
  }
}
class BooleanArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    BooleanArraySerializer_instance = null;
    super(serializer_12(BooleanCompanionObject_instance));
    BooleanArraySerializer_instance = this;
  }
  vcs(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  pck(_this__u8e3s4) {
    return this.vcs((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  wcs(_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  }
  kcj(_this__u8e3s4) {
    return this.wcs((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  acm() {
    return booleanArray(0);
  }
  xcs(decoder, index, builder, checkIndex) {
    builder.act(decoder.hcg(this.rcl_1, index));
  }
  vcj(decoder, index, builder, checkIndex) {
    return this.xcs(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bcm(decoder, index, builder, checkIndex) {
    return this.xcs(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bct(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.nch(this.rcl_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  ccm(encoder, content, size) {
    return this.bct(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class CharArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.zco_1 = bufferWithData;
    this.acp_1 = bufferWithData.length;
    this.xcl(10);
  }
  tcl() {
    return this.acp_1;
  }
  xcl(requiredCapacity) {
    if (this.zco_1.length < requiredCapacity)
      this.zco_1 = copyOf(this.zco_1, coerceAtLeast(requiredCapacity, imul(this.zco_1.length, 2)));
  }
  bcp(c) {
    this.ecm();
    var tmp = this.zco_1;
    var _unary__edvuaz = this.acp_1;
    this.acp_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  vcl() {
    return copyOf(this.zco_1, this.acp_1);
  }
}
class DoubleArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.icp_1 = bufferWithData;
    this.jcp_1 = bufferWithData.length;
    this.xcl(10);
  }
  tcl() {
    return this.jcp_1;
  }
  xcl(requiredCapacity) {
    if (this.icp_1.length < requiredCapacity)
      this.icp_1 = copyOf_0(this.icp_1, coerceAtLeast(requiredCapacity, imul(this.icp_1.length, 2)));
  }
  kcp(c) {
    this.ecm();
    var tmp = this.icp_1;
    var _unary__edvuaz = this.jcp_1;
    this.jcp_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  vcl() {
    return copyOf_0(this.icp_1, this.jcp_1);
  }
}
class FloatArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.rcp_1 = bufferWithData;
    this.scp_1 = bufferWithData.length;
    this.xcl(10);
  }
  tcl() {
    return this.scp_1;
  }
  xcl(requiredCapacity) {
    if (this.rcp_1.length < requiredCapacity)
      this.rcp_1 = copyOf_1(this.rcp_1, coerceAtLeast(requiredCapacity, imul(this.rcp_1.length, 2)));
  }
  tcp(c) {
    this.ecm();
    var tmp = this.rcp_1;
    var _unary__edvuaz = this.scp_1;
    this.scp_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  vcl() {
    return copyOf_1(this.rcp_1, this.scp_1);
  }
}
class LongArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.acq_1 = bufferWithData;
    this.bcq_1 = bufferWithData.length;
    this.xcl(10);
  }
  tcl() {
    return this.bcq_1;
  }
  xcl(requiredCapacity) {
    if (this.acq_1.length < requiredCapacity)
      this.acq_1 = copyOf_2(this.acq_1, coerceAtLeast(requiredCapacity, imul(this.acq_1.length, 2)));
  }
  ccq(c) {
    this.ecm();
    var tmp = this.acq_1;
    var _unary__edvuaz = this.bcq_1;
    this.bcq_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  vcl() {
    return copyOf_2(this.acq_1, this.bcq_1);
  }
}
class ULongArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.kcq_1 = bufferWithData;
    this.lcq_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.xcl(10);
  }
  tcl() {
    return this.lcq_1;
  }
  xcl(requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.kcq_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.kcq_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.kcq_1), 2));
      tmp.kcq_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
    }
  }
  mcq(c) {
    this.ecm();
    var tmp = this.kcq_1;
    var _unary__edvuaz = this.lcq_1;
    this.lcq_1 = _unary__edvuaz + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
  }
  cct() {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.kcq_1;
    var newSize = this.lcq_1;
    return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
  }
  vcl() {
    return new ULongArray(this.cct());
  }
}
class IntArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.tcq_1 = bufferWithData;
    this.ucq_1 = bufferWithData.length;
    this.xcl(10);
  }
  tcl() {
    return this.ucq_1;
  }
  xcl(requiredCapacity) {
    if (this.tcq_1.length < requiredCapacity)
      this.tcq_1 = copyOf_3(this.tcq_1, coerceAtLeast(requiredCapacity, imul(this.tcq_1.length, 2)));
  }
  vcq(c) {
    this.ecm();
    var tmp = this.tcq_1;
    var _unary__edvuaz = this.ucq_1;
    this.ucq_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  vcl() {
    return copyOf_3(this.tcq_1, this.ucq_1);
  }
}
class UIntArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.dcr_1 = bufferWithData;
    this.ecr_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.xcl(10);
  }
  tcl() {
    return this.ecr_1;
  }
  xcl(requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.dcr_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.dcr_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.dcr_1), 2));
      tmp.dcr_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
    }
  }
  fcr(c) {
    this.ecm();
    var tmp = this.dcr_1;
    var _unary__edvuaz = this.ecr_1;
    this.ecr_1 = _unary__edvuaz + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
  }
  dct() {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.dcr_1;
    var newSize = this.ecr_1;
    return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
  }
  vcl() {
    return new UIntArray(this.dct());
  }
}
class ShortArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.mcr_1 = bufferWithData;
    this.ncr_1 = bufferWithData.length;
    this.xcl(10);
  }
  tcl() {
    return this.ncr_1;
  }
  xcl(requiredCapacity) {
    if (this.mcr_1.length < requiredCapacity)
      this.mcr_1 = copyOf_4(this.mcr_1, coerceAtLeast(requiredCapacity, imul(this.mcr_1.length, 2)));
  }
  ocr(c) {
    this.ecm();
    var tmp = this.mcr_1;
    var _unary__edvuaz = this.ncr_1;
    this.ncr_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  vcl() {
    return copyOf_4(this.mcr_1, this.ncr_1);
  }
}
class UShortArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.wcr_1 = bufferWithData;
    this.xcr_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.xcl(10);
  }
  tcl() {
    return this.xcr_1;
  }
  xcl(requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.wcr_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.wcr_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.wcr_1), 2));
      tmp.wcr_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
    }
  }
  ycr(c) {
    this.ecm();
    var tmp = this.wcr_1;
    var _unary__edvuaz = this.xcr_1;
    this.xcr_1 = _unary__edvuaz + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
  }
  ect() {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.wcr_1;
    var newSize = this.xcr_1;
    return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
  }
  vcl() {
    return new UShortArray(this.ect());
  }
}
class ByteArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.fcs_1 = bufferWithData;
    this.gcs_1 = bufferWithData.length;
    this.xcl(10);
  }
  tcl() {
    return this.gcs_1;
  }
  xcl(requiredCapacity) {
    if (this.fcs_1.length < requiredCapacity)
      this.fcs_1 = copyOf_5(this.fcs_1, coerceAtLeast(requiredCapacity, imul(this.fcs_1.length, 2)));
  }
  hcs(c) {
    this.ecm();
    var tmp = this.fcs_1;
    var _unary__edvuaz = this.gcs_1;
    this.gcs_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  vcl() {
    return copyOf_5(this.fcs_1, this.gcs_1);
  }
}
class UByteArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.pcs_1 = bufferWithData;
    this.qcs_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.xcl(10);
  }
  tcl() {
    return this.qcs_1;
  }
  xcl(requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.pcs_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.pcs_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.pcs_1), 2));
      tmp.pcs_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
    }
  }
  rcs(c) {
    this.ecm();
    var tmp = this.pcs_1;
    var _unary__edvuaz = this.qcs_1;
    this.qcs_1 = _unary__edvuaz + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
  }
  fct() {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.pcs_1;
    var newSize = this.qcs_1;
    return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
  }
  vcl() {
    return new UByteArray(this.fct());
  }
}
class BooleanArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.ycs_1 = bufferWithData;
    this.zcs_1 = bufferWithData.length;
    this.xcl(10);
  }
  tcl() {
    return this.zcs_1;
  }
  xcl(requiredCapacity) {
    if (this.ycs_1.length < requiredCapacity)
      this.ycs_1 = copyOf_6(this.ycs_1, coerceAtLeast(requiredCapacity, imul(this.ycs_1.length, 2)));
  }
  act(c) {
    this.ecm();
    var tmp = this.ycs_1;
    var _unary__edvuaz = this.zcs_1;
    this.zcs_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  }
  vcl() {
    return copyOf_6(this.ycs_1, this.zcs_1);
  }
}
class StringSerializer {
  constructor() {
    StringSerializer_instance = this;
    this.gct_1 = new PrimitiveSerialDescriptor('kotlin.String', STRING_getInstance());
  }
  jcc() {
    return this.gct_1;
  }
  hct(encoder, value) {
    return encoder.kch(value);
  }
  kcc(encoder, value) {
    return this.hct(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  lcc(decoder) {
    return decoder.acg();
  }
}
class CharSerializer {
  constructor() {
    CharSerializer_instance = this;
    this.ict_1 = new PrimitiveSerialDescriptor('kotlin.Char', CHAR_getInstance());
  }
  jcc() {
    return this.ict_1;
  }
  jct(encoder, value) {
    return encoder.jch(value);
  }
  kcc(encoder, value) {
    return this.jct(encoder, value instanceof Char ? value.n2_1 : THROW_CCE());
  }
  kct(decoder) {
    return decoder.zcf();
  }
  lcc(decoder) {
    return new Char(this.kct(decoder));
  }
}
class DoubleSerializer {
  constructor() {
    DoubleSerializer_instance = this;
    this.lct_1 = new PrimitiveSerialDescriptor('kotlin.Double', DOUBLE_getInstance());
  }
  jcc() {
    return this.lct_1;
  }
  mct(encoder, value) {
    return encoder.ich(value);
  }
  kcc(encoder, value) {
    return this.mct(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  lcc(decoder) {
    return decoder.ycf();
  }
}
class FloatSerializer {
  constructor() {
    FloatSerializer_instance = this;
    this.nct_1 = new PrimitiveSerialDescriptor('kotlin.Float', FLOAT_getInstance());
  }
  jcc() {
    return this.nct_1;
  }
  oct(encoder, value) {
    return encoder.hch(value);
  }
  kcc(encoder, value) {
    return this.oct(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  lcc(decoder) {
    return decoder.xcf();
  }
}
class LongSerializer {
  constructor() {
    LongSerializer_instance = this;
    this.pct_1 = new PrimitiveSerialDescriptor('kotlin.Long', LONG_getInstance());
  }
  jcc() {
    return this.pct_1;
  }
  qct(encoder, value) {
    return encoder.gch(value);
  }
  kcc(encoder, value) {
    return this.qct(encoder, value instanceof Long ? value : THROW_CCE());
  }
  lcc(decoder) {
    return decoder.wcf();
  }
}
class IntSerializer {
  constructor() {
    IntSerializer_instance = this;
    this.rct_1 = new PrimitiveSerialDescriptor('kotlin.Int', INT_getInstance());
  }
  jcc() {
    return this.rct_1;
  }
  sct(encoder, value) {
    return encoder.fch(value);
  }
  kcc(encoder, value) {
    return this.sct(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  lcc(decoder) {
    return decoder.vcf();
  }
}
class ShortSerializer {
  constructor() {
    ShortSerializer_instance = this;
    this.tct_1 = new PrimitiveSerialDescriptor('kotlin.Short', SHORT_getInstance());
  }
  jcc() {
    return this.tct_1;
  }
  uct(encoder, value) {
    return encoder.ech(value);
  }
  kcc(encoder, value) {
    return this.uct(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  lcc(decoder) {
    return decoder.ucf();
  }
}
class ByteSerializer {
  constructor() {
    ByteSerializer_instance = this;
    this.vct_1 = new PrimitiveSerialDescriptor('kotlin.Byte', BYTE_getInstance());
  }
  jcc() {
    return this.vct_1;
  }
  wct(encoder, value) {
    return encoder.dch(value);
  }
  kcc(encoder, value) {
    return this.wct(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  lcc(decoder) {
    return decoder.tcf();
  }
}
class BooleanSerializer {
  constructor() {
    BooleanSerializer_instance = this;
    this.xct_1 = new PrimitiveSerialDescriptor('kotlin.Boolean', BOOLEAN_getInstance());
  }
  jcc() {
    return this.xct_1;
  }
  yct(encoder, value) {
    return encoder.cch(value);
  }
  kcc(encoder, value) {
    return this.yct(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  }
  lcc(decoder) {
    return decoder.scf();
  }
}
class UnitSerializer {
  constructor() {
    UnitSerializer_instance = this;
    this.zct_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
  }
  acu(encoder, value) {
    this.zct_1.zcc(encoder, Unit_instance);
  }
  kcc(encoder, value) {
    return this.acu(encoder, value instanceof Unit ? value : THROW_CCE());
  }
  bcu(decoder) {
    this.zct_1.lcc(decoder);
  }
  lcc(decoder) {
    this.bcu(decoder);
    return Unit_instance;
  }
  jcc() {
    return this.zct_1.jcc();
  }
}
class PrimitiveSerialDescriptor {
  constructor(serialName, kind) {
    this.ccu_1 = serialName;
    this.dcu_1 = kind;
  }
  ice() {
    return this.ccu_1;
  }
  oce() {
    return this.dcu_1;
  }
  qce() {
    return 0;
  }
  jce(index) {
    error_0(this);
  }
  kce(name) {
    error_0(this);
  }
  nce(index) {
    error_0(this);
  }
  mce(index) {
    error_0(this);
  }
  lce(index) {
    error_0(this);
  }
  toString() {
    return 'PrimitiveDescriptor(' + this.ccu_1 + ')';
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor))
      return false;
    if (this.ccu_1 === other.ccu_1 && equals(this.dcu_1, other.dcu_1))
      return true;
    return false;
  }
  hashCode() {
    return getStringHashCode(this.ccu_1) + imul(31, this.dcu_1.hashCode()) | 0;
  }
}
class TaggedDecoder {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.jcu_1 = ArrayList.i1();
    this.kcu_1 = false;
  }
  ucg() {
    return EmptySerializersModule_0();
  }
  ocu(tag) {
    throw SerializationException.icd(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  }
  pcu(tag) {
    return true;
  }
  qcu(tag) {
    var tmp = this.ocu(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  }
  rcu(tag) {
    var tmp = this.ocu(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  scu(tag) {
    var tmp = this.ocu(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  tcu(tag) {
    var tmp = this.ocu(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  ucu(tag) {
    var tmp = this.ocu(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  }
  vcu(tag) {
    var tmp = this.ocu(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  wcu(tag) {
    var tmp = this.ocu(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  xcu(tag) {
    var tmp = this.ocu(tag);
    return tmp instanceof Char ? tmp.n2_1 : THROW_CCE();
  }
  ycu(tag) {
    var tmp = this.ocu(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  }
  zcu(tag, enumDescriptor) {
    var tmp = this.ocu(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  }
  acv(tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeTaggedInline.<anonymous>' call
    this.bcv(tag);
    return this;
  }
  dcg(deserializer, previousValue) {
    return this.ecg(deserializer);
  }
  ccg(descriptor) {
    return this.acv(this.ccv(), descriptor);
  }
  qcf() {
    var tmp0_elvis_lhs = this.lcu();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.pcu(currentTag);
  }
  rcf() {
    return null;
  }
  scf() {
    return this.qcu(this.ccv());
  }
  tcf() {
    return this.rcu(this.ccv());
  }
  ucf() {
    return this.scu(this.ccv());
  }
  vcf() {
    return this.tcu(this.ccv());
  }
  wcf() {
    return this.ucu(this.ccv());
  }
  xcf() {
    return this.vcu(this.ccv());
  }
  ycf() {
    return this.wcu(this.ccv());
  }
  zcf() {
    return this.xcu(this.ccv());
  }
  acg() {
    return this.ycu(this.ccv());
  }
  bcg(enumDescriptor) {
    return this.zcu(this.ccv(), enumDescriptor);
  }
  fcg(descriptor) {
    return this;
  }
  gcg(descriptor) {
  }
  hcg(descriptor, index) {
    return this.qcu(this.gcu(descriptor, index));
  }
  icg(descriptor, index) {
    return this.rcu(this.gcu(descriptor, index));
  }
  jcg(descriptor, index) {
    return this.scu(this.gcu(descriptor, index));
  }
  kcg(descriptor, index) {
    return this.tcu(this.gcu(descriptor, index));
  }
  lcg(descriptor, index) {
    return this.ucu(this.gcu(descriptor, index));
  }
  mcg(descriptor, index) {
    return this.vcu(this.gcu(descriptor, index));
  }
  ncg(descriptor, index) {
    return this.wcu(this.gcu(descriptor, index));
  }
  ocg(descriptor, index) {
    return this.xcu(this.gcu(descriptor, index));
  }
  pcg(descriptor, index) {
    return this.ycu(this.gcu(descriptor, index));
  }
  qcg(descriptor, index) {
    return this.acv(this.gcu(descriptor, index), descriptor.mce(index));
  }
  rcg(descriptor, index, deserializer, previousValue) {
    var tmp = this.gcu(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  }
  tcg(descriptor, index, deserializer, previousValue) {
    var tmp = this.gcu(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  }
  lcu() {
    return lastOrNull(this.jcu_1);
  }
  bcv(name) {
    this.jcu_1.h(name);
  }
  ccv() {
    var r = this.jcu_1.r3(get_lastIndex_0(this.jcu_1));
    this.kcu_1 = true;
    return r;
  }
}
class NamedValueDecoder extends TaggedDecoder {
  gcu(_this__u8e3s4, index) {
    return this.icu(this.hcu(_this__u8e3s4, index));
  }
  icu(nestedName) {
    var tmp0_elvis_lhs = this.lcu();
    return this.mcu(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  }
  hcu(descriptor, index) {
    return descriptor.jce(index);
  }
  mcu(parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  }
  ncu() {
    return this.jcu_1.g1() ? '$' : joinToString(this.jcu_1, '.', '$.');
  }
}
class MapEntry {
  constructor(key, value) {
    this.dcv_1 = key;
    this.ecv_1 = value;
  }
  t1() {
    return this.dcv_1;
  }
  u1() {
    return this.ecv_1;
  }
  toString() {
    return 'MapEntry(key=' + toString_0(this.dcv_1) + ', value=' + toString_0(this.ecv_1) + ')';
  }
  hashCode() {
    var result = this.dcv_1 == null ? 0 : hashCode(this.dcv_1);
    result = imul(result, 31) + (this.ecv_1 == null ? 0 : hashCode(this.ecv_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.dcv_1, tmp0_other_with_cast.dcv_1))
      return false;
    if (!equals(this.ecv_1, tmp0_other_with_cast.ecv_1))
      return false;
    return true;
  }
}
class KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    this.ncv_1 = keySerializer;
    this.ocv_1 = valueSerializer;
  }
  pcv(encoder, value) {
    var structuredEncoder = encoder.fcg(this.jcc());
    structuredEncoder.xch(this.jcc(), 0, this.ncv_1, this.jcv(value));
    structuredEncoder.xch(this.jcc(), 1, this.ocv_1, this.lcv(value));
    structuredEncoder.gcg(this.jcc());
  }
  kcc(encoder, value) {
    return this.pcv(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  lcc(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.jcc();
    var composite = decoder.fcg(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.KeyValueSerializer.deserialize.<anonymous>' call
      if (composite.vcg()) {
        var key = composite.scg(this.jcc(), 0, this.ncv_1);
        var value = composite.scg(this.jcc(), 1, this.ocv_1);
        tmp$ret$0 = this.mcv(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.wcg(this.jcc());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.scg(this.jcc(), 0, this.ncv_1);
            break;
          case 1:
            value_0 = composite.scg(this.jcc(), 1, this.ocv_1);
            break;
          default:
            throw SerializationException.icd('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException.icd("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException.icd("Element 'value' is missing");
      var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
      tmp$ret$0 = this.mcv(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
    }
    var result = tmp$ret$0;
    composite.gcg(descriptor);
    return result;
  }
}
class MapEntrySerializer extends KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    super(keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.hcv_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  jcc() {
    return this.hcv_1;
  }
  icv(_this__u8e3s4) {
    return _this__u8e3s4.t1();
  }
  jcv(_this__u8e3s4) {
    return this.icv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  kcv(_this__u8e3s4) {
    return _this__u8e3s4.u1();
  }
  lcv(_this__u8e3s4) {
    return this.kcv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  mcv(key, value) {
    return new MapEntry(key, value);
  }
}
class PairSerializer extends KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    super(keySerializer, valueSerializer);
    var tmp = this;
    tmp.scv_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  jcc() {
    return this.scv_1;
  }
  tcv(_this__u8e3s4) {
    return _this__u8e3s4.sl_1;
  }
  jcv(_this__u8e3s4) {
    return this.tcv(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  }
  ucv(_this__u8e3s4) {
    return _this__u8e3s4.tl_1;
  }
  lcv(_this__u8e3s4) {
    return this.ucv(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  }
  mcv(key, value) {
    return to(key, value);
  }
}
class TripleSerializer {
  constructor(aSerializer, bSerializer, cSerializer) {
    this.vcv_1 = aSerializer;
    this.wcv_1 = bSerializer;
    this.xcv_1 = cSerializer;
    var tmp = this;
    tmp.ycv_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  jcc() {
    return this.ycv_1;
  }
  zcv(encoder, value) {
    var structuredEncoder = encoder.fcg(this.ycv_1);
    structuredEncoder.xch(this.ycv_1, 0, this.vcv_1, value.at_1);
    structuredEncoder.xch(this.ycv_1, 1, this.wcv_1, value.bt_1);
    structuredEncoder.xch(this.ycv_1, 2, this.xcv_1, value.ct_1);
    structuredEncoder.gcg(this.ycv_1);
  }
  kcc(encoder, value) {
    return this.zcv(encoder, value instanceof Triple ? value : THROW_CCE());
  }
  lcc(decoder) {
    var composite = decoder.fcg(this.ycv_1);
    if (composite.vcg()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  }
}
class ULongSerializer {
  constructor() {
    ULongSerializer_instance = this;
    this.acw_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_4(Companion_getInstance_1()));
  }
  jcc() {
    return this.acw_1;
  }
  bcw(encoder, value) {
    var tmp = encoder.mch(this.acw_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.gch(tmp$ret$0);
  }
  kcc(encoder, value) {
    return this.bcw(encoder, value instanceof ULong ? value.cu_1 : THROW_CCE());
  }
  ccw(decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.ccg(this.acw_1).wcf();
    return _ULong___init__impl__c78o9k(this_0);
  }
  lcc(decoder) {
    return new ULong(this.ccw(decoder));
  }
}
class UIntSerializer {
  constructor() {
    UIntSerializer_instance = this;
    this.dcw_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_6(IntCompanionObject_instance));
  }
  jcc() {
    return this.dcw_1;
  }
  ecw(encoder, value) {
    var tmp = encoder.mch(this.dcw_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.fch(tmp$ret$0);
  }
  kcc(encoder, value) {
    return this.ecw(encoder, value instanceof UInt ? value.st_1 : THROW_CCE());
  }
  fcw(decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.ccg(this.dcw_1).vcf();
    return _UInt___init__impl__l7qpdl(this_0);
  }
  lcc(decoder) {
    return new UInt(this.fcw(decoder));
  }
}
class UShortSerializer {
  constructor() {
    UShortSerializer_instance = this;
    this.gcw_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_8(ShortCompanionObject_instance));
  }
  jcc() {
    return this.gcw_1;
  }
  hcw(encoder, value) {
    var tmp = encoder.mch(this.gcw_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.ech(tmp$ret$0);
  }
  kcc(encoder, value) {
    return this.hcw(encoder, value instanceof UShort ? value.mu_1 : THROW_CCE());
  }
  icw(decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.ccg(this.gcw_1).ucf();
    return _UShort___init__impl__jigrne(this_0);
  }
  lcc(decoder) {
    return new UShort(this.icw(decoder));
  }
}
class UByteSerializer {
  constructor() {
    UByteSerializer_instance = this;
    this.jcw_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_10(ByteCompanionObject_instance));
  }
  jcc() {
    return this.jcw_1;
  }
  kcw(encoder, value) {
    var tmp = encoder.mch(this.jcw_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.dch(tmp$ret$0);
  }
  kcc(encoder, value) {
    return this.kcw(encoder, value instanceof UByte ? value.it_1 : THROW_CCE());
  }
  lcw(decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.ccg(this.jcw_1).tcf();
    return _UByte___init__impl__g9hnc4(this_0);
  }
  lcc(decoder) {
    return new UByte(this.lcw(decoder));
  }
}
class SerializersModule {
  ace(kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.bce(kClass, typeArgumentsSerializers) : $super.bce.call(this, kClass, typeArgumentsSerializers);
  }
}
class SerialModuleImpl extends SerializersModule {
  constructor(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
    super();
    this.ncw_1 = class2ContextualFactory;
    this.ocw_1 = polyBase2Serializers;
    this.pcw_1 = polyBase2DefaultSerializerProvider;
    this.qcw_1 = polyBase2NamedSerializers;
    this.rcw_1 = polyBase2DefaultDeserializerProvider;
    this.scw_1 = hasInterfaceContextualSerializers;
  }
  zcd() {
    return this.scw_1;
  }
  fci(baseClass, value) {
    if (!baseClass.of(value))
      return null;
    var tmp28_safe_receiver = this.ocw_1.h3(baseClass);
    var tmp = tmp28_safe_receiver == null ? null : tmp28_safe_receiver.h3(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.pcw_1.h3(baseClass);
    var tmp29_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp29_safe_receiver == null ? null : tmp29_safe_receiver(value);
  }
  eci(baseClass, serializedClassName) {
    var tmp30_safe_receiver = this.qcw_1.h3(baseClass);
    var tmp;
    if (tmp30_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp30_safe_receiver, KtMap) ? tmp30_safe_receiver : THROW_CCE()).h3(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.rcw_1.h3(baseClass);
    var tmp31_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp31_safe_receiver == null ? null : tmp31_safe_receiver(serializedClassName);
  }
  bce(kClass, typeArgumentsSerializers) {
    var tmp32_safe_receiver = this.ncw_1.h3(kClass);
    var tmp = tmp32_safe_receiver == null ? null : tmp32_safe_receiver.tcw(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  }
  mcw(collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.ncw_1.s1().a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.t1();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.u1();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.wcw_1;
        collector.xcw(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.vcw(kclass, serial.ucw_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = this.ocw_1.s1().a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.t1();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.u1();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = classMap.s1().a1();
      while (tmp0_iterator_1.b1()) {
        var element_1 = tmp0_iterator_1.c1();
        // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.t1();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.u1();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$9 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.ycw(tmp_1, tmp_2, tmp$ret$9);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_2 = this.pcw_1.s1().a1();
    while (tmp0_iterator_2.b1()) {
      var element_2 = tmp0_iterator_2.c1();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.t1();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.u1();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.zcw(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_3 = this.rcw_1.s1().a1();
    while (tmp0_iterator_3.b1()) {
      var element_3 = tmp0_iterator_3.c1();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.t1();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.u1();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.acx(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  }
}
class ContextualProvider {}
class Argless extends ContextualProvider {}
class WithTypeArguments extends ContextualProvider {}
class SerializersModuleCollector {}
function contextual(kClass, serializer) {
  return this.vcw(kClass, SerializersModuleCollector$contextual$lambda(serializer));
}
class SerializableWith {
  constructor(serializer) {
    this.bcx_1 = serializer;
  }
  equals(other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.bcx_1.equals(tmp0_other_with_cast.bcx_1))
      return false;
    return true;
  }
  hashCode() {
    return imul(getStringHashCode('serializer'), 127) ^ this.bcx_1.hashCode();
  }
  toString() {
    return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString(this.bcx_1) + ')';
  }
}
class createCache$1 {
  constructor($factory) {
    this.ccx_1 = $factory;
  }
  cce(key) {
    return this.ccx_1(key);
  }
}
class createParametrizedCache$1 {
  constructor($factory) {
    this.dcx_1 = $factory;
  }
  dce(key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      // Inline function 'kotlinx.serialization.internal.<no name provided>.get.<anonymous>' call
      var value = this.dcx_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
}
//endregion
function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.ucc('type', serializer_0(StringCompanionObject_instance).jcc());
    $this$buildSerialDescriptor.ucc('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.vcc_1.nf() + '>', CONTEXTUAL_getInstance(), []));
    $this$buildSerialDescriptor.occ_1 = this$0.wcc_1;
    return Unit_instance;
  };
}
function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
  return function () {
    var tmp = OPEN_getInstance();
    return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.vcc_1);
  };
}
function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.bcd(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.ycc());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.acd(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.ycc());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function descriptor$factory() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.jcc();
  }, null);
}
function descriptor$factory_0() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.jcc();
  }, null);
}
function init_kotlinx_serialization_SerializationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.gcd_1);
}
function serializerOrNull(_this__u8e3s4) {
  var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
}
function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
  var tmp;
  if (failOnMissingTypeArgSerializer) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(typeArguments, 10));
    var tmp0_iterator = typeArguments.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
      var tmp$ret$0 = serializer(_this__u8e3s4, item);
      destination.h(tmp$ret$0);
    }
    tmp = destination;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(typeArguments, 10));
    var tmp0_iterator_0 = typeArguments.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
      var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var tmp$ret$3 = tmp_0;
      destination_0.h(tmp$ret$3);
    }
    tmp = destination_0;
  }
  var serializers = tmp;
  return serializers;
}
function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
  return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
}
function serializer(_this__u8e3s4, type) {
  var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    platformSpecificSerializerNotRegistered(kclass(type));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function serializerOrNull_0(_this__u8e3s4, type) {
  return serializerByKTypeImpl(_this__u8e3s4, type, false);
}
function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
  var tmp;
  if (_this__u8e3s4.equals(getKClass(Collection)) || _this__u8e3s4.equals(getKClass(KtList)) || (_this__u8e3s4.equals(getKClass(KtMutableList)) || _this__u8e3s4.equals(getKClass(ArrayList)))) {
    tmp = new ArrayListSerializer(serializers.d1(0));
  } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
    tmp = new HashSetSerializer(serializers.d1(0));
  } else if (_this__u8e3s4.equals(getKClass(KtSet)) || (_this__u8e3s4.equals(getKClass(KtMutableSet)) || _this__u8e3s4.equals(getKClass(LinkedHashSet)))) {
    tmp = new LinkedHashSetSerializer(serializers.d1(0));
  } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
    tmp = new HashMapSerializer(serializers.d1(0), serializers.d1(1));
  } else if (_this__u8e3s4.equals(getKClass(KtMap)) || (_this__u8e3s4.equals(getKClass(KtMutableMap)) || _this__u8e3s4.equals(getKClass(LinkedHashMap)))) {
    tmp = new LinkedHashMapSerializer(serializers.d1(0), serializers.d1(1));
  } else if (_this__u8e3s4.equals(getKClass(Entry))) {
    tmp = MapEntrySerializer_0(serializers.d1(0), serializers.d1(1));
  } else if (_this__u8e3s4.equals(getKClass(Pair))) {
    tmp = PairSerializer_0(serializers.d1(0), serializers.d1(1));
  } else if (_this__u8e3s4.equals(getKClass(Triple))) {
    tmp = TripleSerializer_0(serializers.d1(0), serializers.d1(1), serializers.d1(2));
  } else {
    var tmp_0;
    if (isReferenceArray(_this__u8e3s4)) {
      var tmp_1 = elementClassifierIfArray();
      tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.d1(0));
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(serializers);
  return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
}
function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
  var rootClass = kclass(type);
  var isNullable = type.dg();
  // Inline function 'kotlin.collections.map' call
  var this_0 = type.cg();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var item = tmp0_iterator.c1();
    var tmp$ret$0 = typeOrThrow(item);
    destination.h(tmp$ret$0);
  }
  var typeArguments = destination;
  var tmp;
  if (typeArguments.g1()) {
    var tmp_0;
    if (isInterface_0(rootClass) && !(_this__u8e3s4.ace(rootClass) == null)) {
      tmp_0 = null;
    } else {
      tmp_0 = findCachedSerializer(rootClass, isNullable);
    }
    tmp = tmp_0;
  } else {
    var tmp_1;
    if (_this__u8e3s4.zcd()) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_2;
      if (_Result___get_isFailure__impl__jpiriv(this_1)) {
        tmp_2 = null;
      } else {
        var tmp_3 = _Result___get_value__impl__bjfvqg(this_1);
        tmp_2 = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
      }
      tmp_1 = tmp_2;
    }
    tmp = tmp_1;
  }
  var cachedSerializer = tmp;
  if (!(cachedSerializer == null))
    return cachedSerializer;
  var tmp_4;
  if (typeArguments.g1()) {
    var tmp0_elvis_lhs = serializerOrNull(rootClass);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.ace(rootClass) : tmp0_elvis_lhs;
    var tmp_5;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_5 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
    } else {
      tmp_5 = tmp1_elvis_lhs;
    }
    tmp_4 = tmp_5;
  } else {
    var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
    var tmp_6;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_6 = tmp2_elvis_lhs;
    }
    var serializers = tmp_6;
    var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
    var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.bce(rootClass, serializers) : tmp3_elvis_lhs;
    var tmp_7;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp_7 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
    } else {
      tmp_7 = tmp4_elvis_lhs;
    }
    tmp_4 = tmp_7;
  }
  var contextualSerializer = tmp_4;
  var tmp_8;
  if (contextualSerializer == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_8 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
  }
  var tmp4_safe_receiver = tmp_8;
  return tmp4_safe_receiver == null ? null : nullable(tmp4_safe_receiver, isNullable);
}
function nullable(_this__u8e3s4, shouldBeNullable) {
  if (shouldBeNullable)
    return get_nullable(_this__u8e3s4);
  return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
}
function serializerByKTypeImpl$lambda($typeArguments) {
  return function () {
    return $typeArguments.d1(0).bg();
  };
}
function get_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE;
}
var SERIALIZERS_CACHE;
function get_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return SERIALIZERS_CACHE_NULLABLE;
}
var SERIALIZERS_CACHE_NULLABLE;
function get_PARAMETRIZED_SERIALIZERS_CACHE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE;
}
var PARAMETRIZED_SERIALIZERS_CACHE;
function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
  _init_properties_SerializersCache_kt__hgwi2p();
  return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
}
var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
function findCachedSerializer(clazz, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp12_safe_receiver = get_SERIALIZERS_CACHE().cce(clazz);
    var tmp_0;
    if (tmp12_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_0 = isInterface(tmp12_safe_receiver, KSerializer) ? tmp12_safe_receiver : THROW_CCE();
    }
    tmp = tmp_0;
  } else {
    tmp = get_SERIALIZERS_CACHE_NULLABLE().cce(clazz);
  }
  return tmp;
}
function findParametrizedCachedSerializer(clazz, types, isNullable) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp;
  if (!isNullable) {
    var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().dce(clazz, types);
    tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
  } else {
    tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().dce(clazz, types);
  }
  return tmp;
}
function SERIALIZERS_CACHE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var tmp0_elvis_lhs = serializerOrNull(it);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
    tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp8_safe_receiver = tmp;
  var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : get_nullable(tmp8_safe_receiver);
  var tmp_0;
  if (tmp9_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp_0 = isInterface(tmp9_safe_receiver, KSerializer) ? tmp9_safe_receiver : THROW_CCE();
  }
  return tmp_0;
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
}
function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
  return function () {
    return $types.d1(0).bg();
  };
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
  _init_properties_SerializersCache_kt__hgwi2p();
  var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
  var tmp10_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
  var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : get_nullable(tmp10_safe_receiver);
  var tmp;
  if (tmp11_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlinx.serialization.internal.cast' call
    tmp = isInterface(tmp11_safe_receiver, KSerializer) ? tmp11_safe_receiver : THROW_CCE();
  }
  return tmp;
}
function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
  return function () {
    return $types.d1(0).bg();
  };
}
var properties_initialized_SerializersCache_kt_q8kf25;
function _init_properties_SerializersCache_kt__hgwi2p() {
  if (!properties_initialized_SerializersCache_kt_q8kf25) {
    properties_initialized_SerializersCache_kt_q8kf25 = true;
    SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
    SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
    PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
  }
}
function get_nullable(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.jcc().ece()) {
    tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  } else {
    tmp = new NullableSerializer(_this__u8e3s4);
  }
  return tmp;
}
function serializer_0(_this__u8e3s4) {
  return StringSerializer_getInstance();
}
function serializer_1(_this__u8e3s4) {
  return CharSerializer_getInstance();
}
function CharArraySerializer_0() {
  return CharArraySerializer_getInstance();
}
function serializer_2(_this__u8e3s4) {
  return DoubleSerializer_getInstance();
}
function DoubleArraySerializer_0() {
  return DoubleArraySerializer_getInstance();
}
function serializer_3(_this__u8e3s4) {
  return FloatSerializer_getInstance();
}
function FloatArraySerializer_0() {
  return FloatArraySerializer_getInstance();
}
function serializer_4(_this__u8e3s4) {
  return LongSerializer_getInstance();
}
function LongArraySerializer_0() {
  return LongArraySerializer_getInstance();
}
function serializer_5(_this__u8e3s4) {
  return ULongSerializer_getInstance();
}
function ULongArraySerializer_0() {
  return ULongArraySerializer_getInstance();
}
function serializer_6(_this__u8e3s4) {
  return IntSerializer_getInstance();
}
function IntArraySerializer_0() {
  return IntArraySerializer_getInstance();
}
function serializer_7(_this__u8e3s4) {
  return UIntSerializer_getInstance();
}
function UIntArraySerializer_0() {
  return UIntArraySerializer_getInstance();
}
function serializer_8(_this__u8e3s4) {
  return ShortSerializer_getInstance();
}
function ShortArraySerializer_0() {
  return ShortArraySerializer_getInstance();
}
function serializer_9(_this__u8e3s4) {
  return UShortSerializer_getInstance();
}
function UShortArraySerializer_0() {
  return UShortArraySerializer_getInstance();
}
function serializer_10(_this__u8e3s4) {
  return ByteSerializer_getInstance();
}
function ByteArraySerializer_0() {
  return ByteArraySerializer_getInstance();
}
function serializer_11(_this__u8e3s4) {
  return UByteSerializer_getInstance();
}
function UByteArraySerializer_0() {
  return UByteArraySerializer_getInstance();
}
function serializer_12(_this__u8e3s4) {
  return BooleanSerializer_getInstance();
}
function BooleanArraySerializer_0() {
  return BooleanArraySerializer_getInstance();
}
function serializer_13(_this__u8e3s4) {
  return UnitSerializer_getInstance();
}
function NothingSerializer_0() {
  return NothingSerializer_getInstance();
}
function serializer_14(_this__u8e3s4) {
  return DurationSerializer_getInstance();
}
function MapEntrySerializer_0(keySerializer, valueSerializer) {
  return new MapEntrySerializer(keySerializer, valueSerializer);
}
function PairSerializer_0(keySerializer, valueSerializer) {
  return new PairSerializer(keySerializer, valueSerializer);
}
function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
  return new TripleSerializer(aSerializer, bSerializer, cSerializer);
}
function ArraySerializer(kClass, elementSerializer) {
  return new ReferenceArraySerializer(kClass, elementSerializer);
}
function MapSerializer(keySerializer, valueSerializer) {
  return new LinkedHashMapSerializer(keySerializer, valueSerializer);
}
function ListSerializer(elementSerializer) {
  return new ArrayListSerializer(elementSerializer);
}
function withContext(_this__u8e3s4, context) {
  return new ContextDescriptor(_this__u8e3s4, context);
}
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp14_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp14_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.descriptors.getContextualDescriptor.<anonymous>' call
    var tmp15_safe_receiver = _this__u8e3s4.ace(tmp14_safe_receiver);
    tmp = tmp15_safe_receiver == null ? null : tmp15_safe_receiver.jcc();
  }
  return tmp;
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor) {
    tmp = _this__u8e3s4.gce_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
      tmp = get_capturedKClass(_this__u8e3s4.sce_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function get_elementDescriptors(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new _no_name_provided__qut3iv(_this__u8e3s4);
}
function get_elementNames(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new _no_name_provided__qut3iv_0(_this__u8e3s4);
}
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!isBlank(serialName)) {
    // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.l(toString(message));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!equals(kind, CLASS_getInstance())) {
    // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException.l(toString(message_0));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builder(sdBuilder);
  return new SerialDescriptorImpl(serialName, kind, sdBuilder.pcc_1.e1(), toList(typeParameters), sdBuilder);
}
function _get__hashCode__tgwhef($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.ncf_1;
  _hashCode$factory();
  return this_0.u1();
}
function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.mcf_1);
  };
}
function SerialDescriptorImpl$toString$lambda(this$0) {
  return function (it) {
    return this$0.jce(it) + ': ' + this$0.mce(it).ice();
  };
}
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!isBlank(serialName)) {
    // Inline function 'kotlinx.serialization.descriptors.buildClassSerialDescriptor.<anonymous>' call
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.l(toString(message));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builderAction(sdBuilder);
  return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.pcc_1.e1(), toList(typeParameters), sdBuilder);
}
function PrimitiveSerialDescriptor_0(serialName, kind) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!isBlank(serialName)) {
    // Inline function 'kotlinx.serialization.descriptors.PrimitiveSerialDescriptor.<anonymous>' call
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.l(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function _hashCode$factory() {
  return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
    return _get__hashCode__tgwhef(receiver);
  }, null);
}
var ENUM_instance;
function ENUM_getInstance() {
  if (ENUM_instance === VOID)
    new ENUM();
  return ENUM_instance;
}
var CONTEXTUAL_instance;
function CONTEXTUAL_getInstance() {
  if (CONTEXTUAL_instance === VOID)
    new CONTEXTUAL();
  return CONTEXTUAL_instance;
}
var SEALED_instance;
function SEALED_getInstance() {
  if (SEALED_instance === VOID)
    new SEALED();
  return SEALED_instance;
}
var OPEN_instance;
function OPEN_getInstance() {
  if (OPEN_instance === VOID)
    new OPEN();
  return OPEN_instance;
}
var BOOLEAN_instance;
function BOOLEAN_getInstance() {
  if (BOOLEAN_instance === VOID)
    new BOOLEAN();
  return BOOLEAN_instance;
}
var BYTE_instance;
function BYTE_getInstance() {
  if (BYTE_instance === VOID)
    new BYTE();
  return BYTE_instance;
}
var CHAR_instance;
function CHAR_getInstance() {
  if (CHAR_instance === VOID)
    new CHAR();
  return CHAR_instance;
}
var SHORT_instance;
function SHORT_getInstance() {
  if (SHORT_instance === VOID)
    new SHORT();
  return SHORT_instance;
}
var INT_instance;
function INT_getInstance() {
  if (INT_instance === VOID)
    new INT();
  return INT_instance;
}
var LONG_instance;
function LONG_getInstance() {
  if (LONG_instance === VOID)
    new LONG();
  return LONG_instance;
}
var FLOAT_instance;
function FLOAT_getInstance() {
  if (FLOAT_instance === VOID)
    new FLOAT();
  return FLOAT_instance;
}
var DOUBLE_instance;
function DOUBLE_getInstance() {
  if (DOUBLE_instance === VOID)
    new DOUBLE();
  return DOUBLE_instance;
}
var STRING_instance;
function STRING_getInstance() {
  if (STRING_instance === VOID)
    new STRING();
  return STRING_instance;
}
var CLASS_instance;
function CLASS_getInstance() {
  if (CLASS_instance === VOID)
    new CLASS();
  return CLASS_instance;
}
var LIST_instance;
function LIST_getInstance() {
  if (LIST_instance === VOID)
    new LIST();
  return LIST_instance;
}
var MAP_instance;
function MAP_getInstance() {
  if (MAP_instance === VOID)
    new MAP();
  return MAP_instance;
}
var OBJECT_instance;
function OBJECT_getInstance() {
  if (OBJECT_instance === VOID)
    new OBJECT();
  return OBJECT_instance;
}
function decodeSequentially_0($this, compositeDecoder) {
  var klassName = compositeDecoder.pcg($this.jcc(), 0);
  var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
  return compositeDecoder.scg($this.jcc(), 1, serializer);
}
function throwSubtypeNotRegistered(subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.nf();
  throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
}
function throwSubtypeNotRegistered_0(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.nf() + "'";
  throw SerializationException.icd(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.nf() + "' has to be sealed and '@Serializable'."));
}
var NothingSerializer_instance;
function NothingSerializer_getInstance() {
  if (NothingSerializer_instance === VOID)
    new NothingSerializer();
  return NothingSerializer_instance;
}
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance === VOID)
    new DurationSerializer();
  return DurationSerializer_instance;
}
function readSize($this, decoder, builder) {
  var size = decoder.xcg($this.jcc());
  $this.mcj(builder, size);
  return size;
}
var Companion_instance_0;
function Companion_getInstance_6() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
function prepareHighMarksArray($this, elementsCount) {
  var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
  var elementsInLastSlot = elementsCount & 63;
  var highMarks = longArray(slotsCount);
  if (!(elementsInLastSlot === 0)) {
    highMarks[get_lastIndex(highMarks)] = (new Long(-1, -1)).i4(elementsCount);
  }
  return highMarks;
}
function markHigh($this, index) {
  var slot = (index >>> 6 | 0) - 1 | 0;
  var offsetInSlot = index & 63;
  $this.jcm_1[slot] = $this.jcm_1[slot].m4((new Long(1, 0)).i4(offsetInSlot));
}
function nextUnmarkedHighIndex($this) {
  var inductionVariable = 0;
  var last = $this.jcm_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var slot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var slotOffset = imul(slot + 1 | 0, 64);
      var slotMarks = $this.jcm_1[slot];
      while (!slotMarks.equals(new Long(-1, -1))) {
        var indexInSlot = countTrailingZeroBits(slotMarks.h4());
        slotMarks = slotMarks.m4((new Long(1, 0)).i4(indexInSlot));
        var index = slotOffset + indexInSlot | 0;
        if ($this.hcm_1($this.gcm_1, index)) {
          $this.jcm_1[slot] = slotMarks;
          return index;
        }
      }
      $this.jcm_1[slot] = slotMarks;
    }
     while (inductionVariable <= last);
  return -1;
}
function createSimpleEnumSerializer(serialName, values) {
  return new EnumSerializer(serialName, values);
}
function createUnmarkedDescriptor($this, serialName) {
  var d = new EnumDescriptor(serialName, $this.mcm_1.length);
  // Inline function 'kotlin.collections.forEach' call
  var indexedObject = $this.mcm_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlinx.serialization.internal.EnumSerializer.createUnmarkedDescriptor.<anonymous>' call
    d.bcn(element.s3_1);
  }
  return d;
}
function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
  return function () {
    var tmp0_elvis_lhs = this$0.ncm_1;
    return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
  };
}
function _get_elementDescriptors__y23q9p($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.qcn_1;
  elementDescriptors$factory();
  return this_0.u1();
}
function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
  return function () {
    var tmp = 0;
    var tmp_0 = $elementsCount;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.jce(tmp_2), OBJECT_getInstance(), []);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function descriptor$factory_1() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.jcc();
  }, null);
}
function elementDescriptors$factory() {
  return getPropertyCallableRef('elementDescriptors', 1, KProperty1, function (receiver) {
    return _get_elementDescriptors__y23q9p(receiver);
  }, null);
}
function InlinePrimitiveDescriptor(name, primitiveSerializer) {
  return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
}
function jsonCachedSerialNames(_this__u8e3s4) {
  return cachedSerialNames(_this__u8e3s4);
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder.kco();
  return NoOpEncoder_instance;
}
function error($this) {
  throw IllegalStateException.l5('Descriptor for type `kotlin.Nothing` does not have elements');
}
var NothingSerialDescriptor_instance;
function NothingSerialDescriptor_getInstance() {
  if (NothingSerialDescriptor_instance === VOID)
    new NothingSerialDescriptor();
  return NothingSerialDescriptor_instance;
}
function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.occ_1 = this$0.rco_1;
    return Unit_instance;
  };
}
function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return function () {
    var tmp = OBJECT_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function descriptor$factory_2() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.jcc();
  }, null);
}
function get_EMPTY_DESCRIPTOR_ARRAY() {
  _init_properties_Platform_common_kt__3qzecs();
  return EMPTY_DESCRIPTOR_ARRAY;
}
var EMPTY_DESCRIPTOR_ARRAY;
function cachedSerialNames(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  if (isInterface(_this__u8e3s4, CachedNames))
    return _this__u8e3s4.ocf();
  var result = HashSet.l1(_this__u8e3s4.qce());
  var inductionVariable = 0;
  var last = _this__u8e3s4.qce();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = _this__u8e3s4.jce(i);
      result.h(element);
    }
     while (inductionVariable < last);
  return result;
}
function kclass(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var t = _this__u8e3s4.bg();
  var tmp;
  if (!(t == null) ? isInterface(t, KClass) : false) {
    tmp = t;
  } else {
    if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
      throw IllegalArgumentException.l('Captured type parameter ' + toString(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + toString(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString(t) + '.'));
    } else {
      throw IllegalArgumentException.l('Only KClass supported as classifier, got ' + toString_0(t));
    }
  }
  var tmp_0 = tmp;
  return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
}
function typeOrThrow(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    var value = _this__u8e3s4.wq_1;
    // Inline function 'kotlin.contracts.contract' call
    if (value == null) {
      // Inline function 'kotlinx.serialization.internal.typeOrThrow.<anonymous>' call
      var message = 'Star projections in type arguments are not allowed, but had ' + toString_0(_this__u8e3s4.wq_1);
      throw IllegalArgumentException.l(toString(message));
    } else {
      tmp$ret$1 = value;
      break $l$block;
    }
  }
  return tmp$ret$1;
}
function notRegisteredMessage(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  var tmp0_elvis_lhs = _this__u8e3s4.nf();
  return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
}
function compactArray(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  // Inline function 'kotlin.takeUnless' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  // Inline function 'kotlin.contracts.contract' call
  if (!(_this__u8e3s4 == null || _this__u8e3s4.g1())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = null;
  }
  var tmp24_safe_receiver = tmp;
  var tmp_0;
  if (tmp24_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp24_safe_receiver);
  }
  var tmp0_elvis_lhs = tmp_0;
  return tmp0_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp0_elvis_lhs;
}
function notRegisteredMessage_0(className) {
  _init_properties_Platform_common_kt__3qzecs();
  return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
}
var properties_initialized_Platform_common_kt_i7q4ty;
function _init_properties_Platform_common_kt__3qzecs() {
  if (!properties_initialized_Platform_common_kt_i7q4ty) {
    properties_initialized_Platform_common_kt_i7q4ty = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_DESCRIPTOR_ARRAY = [];
  }
}
function throwMissingFieldException(seen, goldenMask, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList.i1();
  var missingFieldsBits = goldenMask & ~seen;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!((missingFieldsBits & 1) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = descriptor.jce(i);
        missingFields.h(element);
      }
      missingFieldsBits = missingFieldsBits >>> 1 | 0;
    }
     while (inductionVariable < 32);
  throw MissingFieldException.ycd(missingFields, descriptor.ice());
}
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.ice());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var tmp0_iterator = elementDescriptors.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
    var tmp0_safe_receiver = element.ice();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var tmp0_iterator_0 = elementDescriptors.a1();
  while (tmp0_iterator_0.b1()) {
    var element_0 = tmp0_iterator_0.c1();
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
    var tmp0_safe_receiver_0 = element_0.oce();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
function _get_childSerializers__7vnyfa($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.ycm_1;
  childSerializers$factory();
  return this_0.u1();
}
function _get__hashCode__tgwhef_0($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.acn_1;
  _hashCode$factory_0();
  return this_0.u1();
}
function buildIndices($this) {
  var indices = HashMap.y8();
  var inductionVariable = 0;
  var last = $this.tcm_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.tcm_1[i];
      indices.j3(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
  return function () {
    var tmp25_safe_receiver = this$0.qcm_1;
    var tmp0_elvis_lhs = tmp25_safe_receiver == null ? null : tmp25_safe_receiver.hco();
    return tmp0_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp0_elvis_lhs;
  };
}
function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
  return function () {
    var tmp26_safe_receiver = this$0.qcm_1;
    var tmp27_safe_receiver = tmp26_safe_receiver == null ? null : tmp26_safe_receiver.ico();
    var tmp;
    if (tmp27_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(tmp27_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp27_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp27_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.jcc();
        destination.h(tmp$ret$0);
      }
      tmp = destination;
    }
    return compactArray(tmp);
  };
}
function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.rcn());
  };
}
function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
  return function (i) {
    return this$0.jce(i) + ': ' + this$0.mce(i).ice();
  };
}
function childSerializers$factory() {
  return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
    return _get_childSerializers__7vnyfa(receiver);
  }, null);
}
function typeParameterDescriptors$factory() {
  return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
    return receiver.rcn();
  }, null);
}
function _hashCode$factory_0() {
  return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
    return _get__hashCode__tgwhef_0(receiver);
  }, null);
}
function get_EMPTY_SERIALIZER_ARRAY() {
  _init_properties_PluginHelperInterfaces_kt__xgvzfp();
  return EMPTY_SERIALIZER_ARRAY;
}
var EMPTY_SERIALIZER_ARRAY;
var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
  if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
    properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_SERIALIZER_ARRAY = [];
  }
}
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance === VOID)
    new CharArraySerializer();
  return CharArraySerializer_instance;
}
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance === VOID)
    new DoubleArraySerializer();
  return DoubleArraySerializer_instance;
}
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance === VOID)
    new FloatArraySerializer();
  return FloatArraySerializer_instance;
}
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance === VOID)
    new LongArraySerializer();
  return LongArraySerializer_instance;
}
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance === VOID)
    new ULongArraySerializer();
  return ULongArraySerializer_instance;
}
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance === VOID)
    new IntArraySerializer();
  return IntArraySerializer_instance;
}
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance === VOID)
    new UIntArraySerializer();
  return UIntArraySerializer_instance;
}
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance === VOID)
    new ShortArraySerializer();
  return ShortArraySerializer_instance;
}
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance === VOID)
    new UShortArraySerializer();
  return UShortArraySerializer_instance;
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new ByteArraySerializer();
  return ByteArraySerializer_instance;
}
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance === VOID)
    new UByteArraySerializer();
  return UByteArraySerializer_instance;
}
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance === VOID)
    new BooleanArraySerializer();
  return BooleanArraySerializer_instance;
}
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().h3(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
}
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance === VOID)
    new StringSerializer();
  return StringSerializer_instance;
}
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance === VOID)
    new CharSerializer();
  return CharSerializer_instance;
}
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance === VOID)
    new DoubleSerializer();
  return DoubleSerializer_instance;
}
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance === VOID)
    new FloatSerializer();
  return FloatSerializer_instance;
}
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance === VOID)
    new LongSerializer();
  return LongSerializer_instance;
}
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance === VOID)
    new IntSerializer();
  return IntSerializer_instance;
}
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance === VOID)
    new ShortSerializer();
  return ShortSerializer_instance;
}
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance === VOID)
    new ByteSerializer();
  return ByteSerializer_instance;
}
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance === VOID)
    new BooleanSerializer();
  return BooleanSerializer_instance;
}
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance === VOID)
    new UnitSerializer();
  return UnitSerializer_instance;
}
function error_0($this) {
  throw IllegalStateException.l5('Primitive descriptor does not have elements');
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkName(serialName);
  return new PrimitiveSerialDescriptor(serialName, kind);
}
function checkName(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var keys = get_BUILTIN_SERIALIZERS().i3();
  var _iterator__ex2g4s = keys.a1();
  while (_iterator__ex2g4s.b1()) {
    var primitive = _iterator__ex2g4s.c1();
    var simpleName = capitalize(ensureNotNull(primitive.nf()));
    var qualifiedName = 'kotlin.' + simpleName;
    if (equals_0(serialName, qualifiedName, true) || equals_0(serialName, simpleName, true)) {
      throw IllegalArgumentException.l(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
function capitalize(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  // Inline function 'kotlin.text.replaceFirstChar' call
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(_this__u8e3s4) > 0) {
    // Inline function 'kotlinx.serialization.internal.capitalize.<anonymous>' call
    var it = charSequenceGet(_this__u8e3s4, 0);
    var tmp$ret$1 = isLowerCase(it) ? titlecase(it) : toString_1(it);
    var tmp_0 = toString(tmp$ret$1);
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = tmp_0 + _this__u8e3s4.substring(1);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = mapOf([to(PrimitiveClasses_getInstance().og(), serializer_0(StringCompanionObject_instance)), to(getKClass(Char), serializer_1(Companion_getInstance_0())), to(PrimitiveClasses_getInstance().rg(), CharArraySerializer_0()), to(PrimitiveClasses_getInstance().mg(), serializer_2(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().xg(), DoubleArraySerializer_0()), to(PrimitiveClasses_getInstance().lg(), serializer_3(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().wg(), FloatArraySerializer_0()), to(getKClass(Long), serializer_4(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().vg(), LongArraySerializer_0()), to(getKClass(ULong), serializer_5(Companion_getInstance_2())), to(getKClass(ULongArray), ULongArraySerializer_0()), to(PrimitiveClasses_getInstance().kg(), serializer_6(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().ug(), IntArraySerializer_0()), to(getKClass(UInt), serializer_7(Companion_getInstance_3())), to(getKClass(UIntArray), UIntArraySerializer_0()), to(PrimitiveClasses_getInstance().jg(), serializer_8(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().tg(), ShortArraySerializer_0()), to(getKClass(UShort), serializer_9(Companion_getInstance_4())), to(getKClass(UShortArray), UShortArraySerializer_0()), to(PrimitiveClasses_getInstance().ig(), serializer_10(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().sg(), ByteArraySerializer_0()), to(getKClass(UByte), serializer_11(Companion_getInstance_5())), to(getKClass(UByteArray), UByteArraySerializer_0()), to(PrimitiveClasses_getInstance().hg(), serializer_12(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().qg(), BooleanArraySerializer_0()), to(getKClass(Unit), serializer_13(Unit_instance)), to(PrimitiveClasses_getInstance().gg(), NothingSerializer_0()), to(getKClass(Duration), serializer_14(Companion_getInstance()))]);
  }
}
function tagBlock($this, tag, block) {
  $this.bcv(tag);
  var r = block();
  if (!$this.kcu_1) {
    $this.ccv();
  }
  $this.kcu_1 = false;
  return r;
}
function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return function () {
    return this$0.dcg($deserializer, $previousValue);
  };
}
function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
  return function () {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var this_0 = this$0;
    var isNullabilitySupported = $deserializer.jcc().ece();
    var tmp;
    if (isNullabilitySupported || this_0.qcf()) {
      // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeNullableSerializableElement.<anonymous>.<anonymous>' call
      tmp = this$0.dcg($deserializer, $previousValue);
    } else {
      tmp = this_0.rcf();
    }
    return tmp;
  };
}
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.ucc('key', $keySerializer.jcc());
    $this$buildSerialDescriptor.ucc('value', $valueSerializer.jcc());
    return Unit_instance;
  };
}
function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.ucc('first', $keySerializer.jcc());
    $this$buildClassSerialDescriptor.ucc('second', $valueSerializer.jcc());
    return Unit_instance;
  };
}
function decodeSequentially_1($this, composite) {
  var a = composite.scg($this.ycv_1, 0, $this.vcv_1);
  var b = composite.scg($this.ycv_1, 1, $this.wcv_1);
  var c = composite.scg($this.ycv_1, 2, $this.xcv_1);
  composite.gcg($this.ycv_1);
  return new Triple(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.wcg($this.ycv_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.scg($this.ycv_1, 0, $this.vcv_1);
        break;
      case 1:
        b = composite.scg($this.ycv_1, 1, $this.wcv_1);
        break;
      case 2:
        c = composite.scg($this.ycv_1, 2, $this.xcv_1);
        break;
      default:
        throw SerializationException.icd('Unexpected index ' + index);
    }
  }
  composite.gcg($this.ycv_1);
  if (a === get_NULL())
    throw SerializationException.icd("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException.icd("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException.icd("Element 'third' is missing");
  var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
  var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
  return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
}
function TripleSerializer$descriptor$lambda(this$0) {
  return function ($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.ucc('first', this$0.vcv_1.jcc());
    $this$buildClassSerialDescriptor.ucc('second', this$0.wcv_1.jcc());
    $this$buildClassSerialDescriptor.ucc('third', this$0.xcv_1.jcc());
    return Unit_instance;
  };
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance === VOID)
    new ULongSerializer();
  return ULongSerializer_instance;
}
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance === VOID)
    new UIntSerializer();
  return UIntSerializer_instance;
}
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance === VOID)
    new UShortSerializer();
  return UShortSerializer_instance;
}
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance === VOID)
    new UByteSerializer();
  return UByteSerializer_instance;
}
function get_EmptySerializersModuleLegacyJs() {
  _init_properties_SerializersModule_kt__u78ha3();
  return EmptySerializersModule;
}
var EmptySerializersModule;
var properties_initialized_SerializersModule_kt_fjigjn;
function _init_properties_SerializersModule_kt__u78ha3() {
  if (!properties_initialized_SerializersModule_kt_fjigjn) {
    properties_initialized_SerializersModule_kt_fjigjn = true;
    EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
  }
}
function EmptySerializersModule_0() {
  return get_EmptySerializersModuleLegacyJs();
}
function SerializersModuleCollector$contextual$lambda($serializer) {
  return function (it) {
    return $serializer;
  };
}
function createCache(factory) {
  return new createCache$1(factory);
}
function createParametrizedCache(factory) {
  return new createParametrizedCache$1(factory);
}
function isInterface_0(_this__u8e3s4) {
  return get_isInterface(_this__u8e3s4);
}
function get_isInterface(_this__u8e3s4) {
  if (_this__u8e3s4 === PrimitiveClasses_getInstance().gg())
    return false;
  // Inline function 'kotlin.js.asDynamic' call
  var tmp1_safe_receiver = get_js(_this__u8e3s4).$metadata$;
  return (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.kind) == 'interface';
}
function compiledSerializerImpl(_this__u8e3s4) {
  var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().gg()) {
      tmp_0 = NothingSerializer_getInstance();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = get_js(_this__u8e3s4).Companion;
      tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
    }
    var tmp_1 = tmp_0;
    tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
  throw SerializationException.icd(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
}
function isReferenceArray(rootClass) {
  return rootClass.equals(PrimitiveClasses_getInstance().ng());
}
function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
  var tmp;
  try {
    // Inline function 'kotlin.reflect.findAssociatedObject' call
    var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
    var tmp_0;
    if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
      tmp_0 = isInterface(assocObject, KSerializer) ? assocObject : THROW_CCE();
    } else {
      if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
        var tmp_1 = assocObject.tco(args.slice());
        tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
      } else {
        tmp_0 = null;
      }
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_2;
    var e = $p;
    tmp_2 = null;
    tmp = tmp_2;
  }
  return tmp;
}
function toNativeArrayImpl(_this__u8e3s4, eClass) {
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(_this__u8e3s4);
}
function getChecked(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException.q1('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function getChecked_0(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException.q1('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
//region block: post-declaration
initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer');
initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer');
initMetadataForClass(SerializationException, 'SerializationException', SerializationException.hcd);
initMetadataForClass(UnknownFieldException, 'UnknownFieldException');
initMetadataForClass(MissingFieldException, 'MissingFieldException');
initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(elementDescriptors$1);
initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(elementNames$1);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
initMetadataForInterface(CachedNames, 'CachedNames');
protoOf(SerialDescriptorImpl).ece = get_isNullable;
protoOf(SerialDescriptorImpl).pce = get_isInline;
initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(SerialKind, 'SerialKind');
initMetadataForObject(ENUM, 'ENUM');
initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL');
initMetadataForClass(PolymorphicKind, 'PolymorphicKind');
initMetadataForObject(SEALED, 'SEALED');
initMetadataForObject(OPEN, 'OPEN');
initMetadataForClass(PrimitiveKind, 'PrimitiveKind');
initMetadataForObject(BOOLEAN, 'BOOLEAN');
initMetadataForObject(BYTE, 'BYTE');
initMetadataForObject(CHAR, 'CHAR');
initMetadataForObject(SHORT, 'SHORT');
initMetadataForObject(INT, 'INT');
initMetadataForObject(LONG, 'LONG');
initMetadataForObject(FLOAT, 'FLOAT');
initMetadataForObject(DOUBLE, 'DOUBLE');
initMetadataForObject(STRING, 'STRING');
initMetadataForClass(StructureKind, 'StructureKind');
initMetadataForObject(CLASS, 'CLASS');
initMetadataForObject(LIST, 'LIST');
initMetadataForObject(MAP, 'MAP');
initMetadataForObject(OBJECT, 'OBJECT');
initMetadataForInterface(Decoder, 'Decoder');
initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
protoOf(AbstractDecoder).scg = decodeSerializableElement$default;
protoOf(AbstractDecoder).ecg = decodeSerializableValue;
protoOf(AbstractDecoder).vcg = decodeSequentially;
protoOf(AbstractDecoder).xcg = decodeCollectionSize;
initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForInterface(Encoder, 'Encoder');
initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
protoOf(AbstractEncoder).bci = encodeNotNullMark;
protoOf(AbstractEncoder).cci = beginCollection;
protoOf(AbstractEncoder).ych = encodeSerializableValue;
protoOf(AbstractEncoder).aci = encodeNullableSerializableValue;
protoOf(AbstractEncoder).dci = shouldEncodeElementDefault;
initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForObject(NothingSerializer, 'NothingSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
protoOf(ListLikeDescriptor).ece = get_isNullable;
protoOf(ListLikeDescriptor).pce = get_isInline;
protoOf(ListLikeDescriptor).rce = get_annotations;
initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc');
initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc');
initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc');
protoOf(MapLikeDescriptor).ece = get_isNullable;
protoOf(MapLikeDescriptor).pce = get_isInline;
protoOf(MapLikeDescriptor).rce = get_annotations;
initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc');
initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc');
initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc');
initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor');
initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer');
initMetadataForClass(CollectionSerializer, 'CollectionSerializer');
initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer');
initMetadataForClass(HashSetSerializer, 'HashSetSerializer');
initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer');
initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer');
initMetadataForClass(HashMapSerializer, 'HashMapSerializer');
initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer');
initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer');
initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer');
initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
initMetadataForCompanion(Companion);
initMetadataForClass(ElementMarker, 'ElementMarker');
initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
protoOf(PluginGeneratedSerialDescriptor).ece = get_isNullable;
protoOf(PluginGeneratedSerialDescriptor).pce = get_isInline;
initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(EnumDescriptor, 'EnumDescriptor');
initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor');
initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
protoOf(InlinePrimitiveDescriptor$1).ico = typeParametersSerializers;
initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
initMetadataForObject(NoOpEncoder, 'NoOpEncoder');
protoOf(NothingSerialDescriptor).ece = get_isNullable;
protoOf(NothingSerialDescriptor).pce = get_isInline;
protoOf(NothingSerialDescriptor).rce = get_annotations;
initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForInterface(SerializerFactory, 'SerializerFactory');
initMetadataForObject(CharArraySerializer, 'CharArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(DoubleArraySerializer, 'DoubleArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(FloatArraySerializer, 'FloatArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(LongArraySerializer, 'LongArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ULongArraySerializer, 'ULongArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(IntArraySerializer, 'IntArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UIntArraySerializer, 'UIntArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ShortArraySerializer, 'ShortArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UShortArraySerializer, 'UShortArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(ByteArraySerializer, 'ByteArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(UByteArraySerializer, 'UByteArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForObject(BooleanArraySerializer, 'BooleanArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder');
initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder');
initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder');
initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder');
initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder');
initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder');
initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder');
initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder');
initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder');
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder');
initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder');
initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder');
initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
protoOf(PrimitiveSerialDescriptor).ece = get_isNullable;
protoOf(PrimitiveSerialDescriptor).pce = get_isInline;
protoOf(PrimitiveSerialDescriptor).rce = get_annotations;
initMetadataForClass(PrimitiveSerialDescriptor, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
protoOf(TaggedDecoder).scg = decodeSerializableElement$default;
protoOf(TaggedDecoder).ecg = decodeSerializableValue;
protoOf(TaggedDecoder).vcg = decodeSequentially;
protoOf(TaggedDecoder).xcg = decodeCollectionSize;
initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder');
initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(MapEntrySerializer, 'MapEntrySerializer');
initMetadataForClass(PairSerializer, 'PairSerializer');
initMetadataForClass(TripleSerializer, 'TripleSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SerializersModule, 'SerializersModule');
initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl');
initMetadataForClass(ContextualProvider, 'ContextualProvider');
initMetadataForClass(Argless, 'Argless');
initMetadataForClass(WithTypeArguments, 'WithTypeArguments');
initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
initMetadataForClass(createCache$1);
initMetadataForClass(createParametrizedCache$1);
//endregion
//region block: exports
export {
  SEALED_getInstance as SEALED_getInstance2brzxtciy6zxg,
  STRING_getInstance as STRING_getInstance2md3nu8ka1da4,
  CONTEXTUAL_getInstance as CONTEXTUAL_getInstance3iftz58z4hzud,
  ENUM_getInstance as ENUM_getInstance3qjro8veu1n4s,
  CLASS_getInstance as CLASS_getInstanceycyg9nehd7tt,
  LIST_getInstance as LIST_getInstance31r89469rgwkw,
  MAP_getInstance as MAP_getInstance242ky2ofgg8p5,
  OBJECT_getInstance as OBJECT_getInstanceoefnxtom5aro,
  BooleanSerializer_getInstance as BooleanSerializer_getInstance1a8uvzxl1s4k4,
  IntSerializer_getInstance as IntSerializer_getInstance3jjhuzya8j8kz,
  LongSerializer_getInstance as LongSerializer_getInstance1b6u8yq9dg9zr,
  StringSerializer_getInstance as StringSerializer_getInstance100dxy5jlaaom,
  ListSerializer as ListSerializer1hxuk9dx5n9du,
  MapSerializer as MapSerializer11kmegt3g5c1g,
  get_nullable as get_nullable197rfua9r7fsz,
  serializer_0 as serializer1x79l67jvwntn,
  serializer_9 as serializer1q7c5q67ysppr,
  serializer_7 as serializer3ikrxnm8b29d6,
  serializer_11 as serializer36584sjyg5661,
  serializer_5 as serializer2lw83vwvpnyms,
  PolymorphicKind as PolymorphicKindla9gurooefwb,
  PrimitiveKind as PrimitiveKindndgbuh6is7ze,
  PrimitiveSerialDescriptor_0 as PrimitiveSerialDescriptor3egfp53lutxj2,
  get_annotations as get_annotationshjxdbdcl8kmv,
  get_isInline as get_isInline5x26qrhi9qs6,
  get_isNullable as get_isNullable36pbikm8xb7bz,
  SerialDescriptor as SerialDescriptor2pelqekb5ic3a,
  ENUM as ENUMlmq49cvwy4ow,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
  CompositeDecoder as CompositeDecoder2tzm7wpwkr0og,
  CompositeEncoder as CompositeEncoderknecpkexzn3v,
  Decoder as Decoder23nde051s631g,
  Encoder as Encoderqvmrpqtq8hnu,
  AbstractPolymorphicSerializer as AbstractPolymorphicSerializer1ccxwp48nfy58,
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  ElementMarker as ElementMarker33ojvsajwmzts,
  typeParametersSerializers as typeParametersSerializers2likxjr48tr7y,
  GeneratedSerializer as GeneratedSerializer1f7t7hssdd2ws,
  InlinePrimitiveDescriptor as InlinePrimitiveDescriptor3i6ccn1a4fw94,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  NamedValueDecoder as NamedValueDecoderzk26ztf92xbq,
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  SerializerFactory as SerializerFactory1qv9hivitncuv,
  createSimpleEnumSerializer as createSimpleEnumSerializer2guioz11kk1m0,
  jsonCachedSerialNames as jsonCachedSerialNameslxufy2gu43jt,
  throwMissingFieldException as throwMissingFieldException2cmke0v3ynf14,
  EmptySerializersModule_0 as EmptySerializersModule991ju6pz9b79,
  contextual as contextual3hpp1gupsu4al,
  SerializersModuleCollector as SerializersModuleCollector3dddz14wd7brg,
  DeserializationStrategy as DeserializationStrategy1z3z5pj9f7zc8,
  KSerializer as KSerializerzf77vz1967fq,
  MissingFieldException as MissingFieldException24tqif29emcmi,
  SealedClassSerializer as SealedClassSerializeriwipiibk55zc,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  SerializationStrategy as SerializationStrategyh6ouydnm6hci,
  UnknownFieldException as UnknownFieldExceptiona60e3a6v1xqo,
  findPolymorphicSerializer_0 as findPolymorphicSerializer1nm87hvemahcj,
  findPolymorphicSerializer as findPolymorphicSerializerk638ixyjovk5,
  serializer as serializer1i4e9ym37oxmo,
};
//endregion
